window.gec.gecUnseal(); // prevent access to private props
window.gec = (function (gec) {
    /************************
    1.Sealer
    2.Methods Definitions
    3.Object/Enum Definitions

    ***********************/

    //this is how we handle private properties over different files
    var gecPrivate = gec.gecPrivate = gec.gecPrivate || {},
        gecSeal = gec.gecSeal = gec.gecSeal || function () {
            delete gec.gecPrivate;
            delete gec.gecSeal;
            delete gec.gecUnseal;
        },
        gecUnseal = gec.gecUnseal = gec.gecUnseal || function () {
            gec.gecPrivate = gecPrivate;
            gec.gecSeal = gecSeal;
            gec.gecUnseal = gecUnseal;
        },
        _deletedOrderIds = {},
        _overlays = [],
        exchangeEventTabs = {},
        subscribedExchangeEventTabs = {};

    var listOrdersChangedSinceXHR, getExchangePricesXHR;
    var _eventsMarkets = {};

    var _fillEvents = function (evenId) {
        var arrayOfEvents = [];
        var eventI = 0;
        for (ev in gecPrivate._eventClassifiers) {
            if (gecPrivate._eventClassifiers[ev]._parentEventClassifierId == evenId) {
                arrayOfEvents[eventI++] = gecPrivate._eventClassifiers[ev];
            }
        }
        arrayOfEvents.sort(gec.SortOnDisplayOrder);
        return arrayOfEvents;
    };

    var _onBlankInfo = function (wcm, headerMatches, bodyObject) {
        alert("_onBlankInfo" + wcm.getHeader());
    };
    var getOrCreateSubscribedSelection = function (selectionId) {
        return gecPrivate._subscribedExchangeSelection[selectionId] = gecPrivate._subscribedExchangeSelection[selectionId] || new gec.SubscribedExchangeSelection();
    };
    var getOrCreateSubscribedMarket = function (marketId) {
        return gecPrivate._subscribedExchangeMarket[marketId] = gecPrivate._subscribedExchangeMarket[marketId] || new gec.SubscribedExchangeMarket();
    };
    var getOrCreateSubscribedEvent = function (eventId) {
        return gecPrivate._subscribedExchangeEvent[eventId] = gecPrivate._subscribedExchangeEvent[eventId] || new gec.SubscribedExchangeEvent();
    };
    var getOrCreateSubscribedEventTabs = function (eventId) {
        return subscribedExchangeEventTabs[eventId] = subscribedExchangeEventTabs[eventId] || new gec.SubscribedExchangeEventTab();
    };
    var getOrCreateEventTabs = function (eventId) {
        return exchangeEventTabs[eventId] = exchangeEventTabs[eventId] || new gec.SubscribedExchangeEventTab();
    };


    var _onSetAnonymousSessionContext = function (webClientMessage, headerMatches, bodyObject) {
        if (gecPrivate._debug) { gecPrivate._base.log("_onSetAnonymousSessionContext"); }
        var correlationId = bodyObject.correlationId;
        var returnCode = bodyObject.returnCode;

        gecPrivate._anonSet = true;
        if (returnCode == 0)
            gecPrivate._correlationData[correlationId].callbackOnSuccess.call(this, {});
        else
            gecPrivate._correlationData[correlationId].callbackOnException.call(this, new gec.AsyncException({ returnCode: returnCode }));

    };
    var _onLogonPunter = function (webClientMessage, headerMatches, bodyObject) {
        if (gecPrivate._debug) { gecPrivate._base.log("_onLogonPunter"); }
        var correlationId = bodyObject[0] * 1;
        var returnCode = bodyObject[1] * 1;

        gecPrivate.removeFromPushMessages(correlationId);

        gecPrivate._anonSet = false;
        if (returnCode != 0) {
            // Log the error 

            gecPrivate.clientLogger.logClientEntry({
                clientLogEntryType: 3,
                componentName: "application",
                subcomponentName: "push",
                logEntry: "Diffusion: logonPunter error: " + returnCode
            });

            if (gecPrivate._correlationData[correlationId].callbackOnException != null) {
                gecPrivate._correlationData[correlationId].callbackOnException.call(this, new gec.AsyncException({ returnCode: returnCode, name: gec.getReturnCodeName(returnCode) }));
            }
        } else {
            gecPrivate.userContextAAPI = {
                debitSportsbookStake: bodyObject[2],
                debitExchangeStake: bodyObject[3],
                purseIntegrationMode: bodyObject[4],
                canPlaceForSideOrders: bodyObject[5],
                canPlaceAgainstSideOrders: bodyObject[6],
                restrictedToFillKillOrders: bodyObject[7],
                currency: bodyObject[8],
                language: bodyObject[9],
                priceFormat: bodyObject[10],
                marketByVolumeAmount: bodyObject[11],
                isRetailPunter: bodyObject[12],
                maximumMessageSize: bodyObject[14]
            };

            gecPrivate._aapiSessionToken = bodyObject[13];

            if (gecPrivate._correlationData[correlationId].callbackOnSuccess != null) {
                gecPrivate._correlationData[correlationId].callbackOnSuccess.call(this, { correlationId: correlationId, userContext: gecPrivate.userContextAAPI });
            }
        }
    };

    var _onLogoffPunter = function (webClientMessage, headerMatches, bodyObject) {
        if (gecPrivate._debug) { gecPrivate._base.log("_onLogoffPunter"); }
        var correlationId = webClientMessage.getFields(0)[1];
        var returnCode = webClientMessage.getFields(1)[1];

        gecPrivate._aapiSessionToken = null;
        if (returnCode != 0) {
            if (gecPrivate._correlationData[correlationId].callbackOnException != null)
                gecPrivate._correlationData[correlationId].callbackOnException.call(this, new gec.AsyncException({ returnCode: returnCode, name: gec.getReturnCodeName(returnCode) }));
        } else {
            if (gecPrivate._correlationData[correlationId].callbackOnSuccess != null)
                gecPrivate._correlationData[correlationId].callbackOnSuccess.call(this, { correlationId: correlationId });


        }
    };

    var _onUnsubscribe = function (webClientMessage, headerMatches, bodyObject) {
        //alert("_onUnsubscribe");
        var correlationId = bodyObject[0] * 1;
        var returnCode = bodyObject[1] * 1;

        gecPrivate.removeFromPushMessages(correlationId);

        if (returnCode == 0) {

            //todo go through all the subscriptionIds and delete and items with interest <=0 ;
            var subIds = gecPrivate._correlationData[correlationId].subscriptionIds;
            if (subIds != null) {
                for (var i = 0; i < subIds.length; i++) {
                    var subId = subIds[i];
                    if (gecPrivate._subscriptions[subId] == null)
                        gecPrivate._subscriptions[subId] = {};
                }
            }

            gecPrivate._correlationData[correlationId].callbackOnSuccess.call(this, { correlationId: correlationId });
        }
        else {
            if (returnCode == null)
                returnCode = 2;
            gecPrivate._correlationData[correlationId].callbackOnException.call(this, new gec.AsyncException({ returnCode: returnCode, name: gec.getReturnCodeName(returnCode) }));
        }
    };

    //General Application Commands
    var _onPing = function (webClientMessage, headerMatches, bodyObject) {

        //todo performance logs here
        var correlationId = bodyObject[0] * 1;
        var returnCode = bodyObject[1] * 1;

        gecPrivate.removeFromPushMessages(correlationId);

        if (returnCode != 0) {


            gecPrivate.clientLogger.logClientEntry({
                clientLogEntryType: 3,
                componentName: "application",
                subcomponentName: "push",
                logEntry: "Diffusion: Ping error: " + returnCode
            });


            alert("PUSH ping error:" + returnCode);
        }

        var request = gecPrivate._correlationData[correlationId];
        messagesInQueue = bodyObject[2];
        var curTime = new Date();
        var lastTime = gecPrivate._base.jsDate(request.currentClientTime);
        gecPrivate._lastPingedAt = lastTime.toISOString();
        gecPrivate._lastPingRoundtripMS = curTime - lastTime;
        _connectionHealth = gecPrivate._lastPingRoundtripMS;

        for (var i in gecPrivate._connectionHealthChangeDelegates) {
            gecPrivate._connectionHealthChangeDelegates[i].call(this, _connectionHealth);
        }


        bodyObject.currentClientTime = curTime;

        gecPrivate.clientLogger.logClientEntry({
            clientLogEntryType: 3,
            componentName: "application",
            subcomponentName: "push",
            logEntry: "Ping Response: " + JSON.stringify(bodyObject)
        });

        if (returnCode === 0) {
            if (gecPrivate._correlationData[correlationId].callbackOnSuccess) {
                gecPrivate._correlationData[correlationId].callbackOnSuccess.call(this, { correlationId: correlationId });
            }

        } else {

            if (gecPrivate._correlationData[correlationId].callbackOnException) {
                gecPrivate._correlationData[correlationId].callbackOnException.call(this, new gec.AsyncException({ returnCode: returnCode, name: gec.getReturnCodeName(returnCode || 2) }));
            }
        }


    };


    var _onSubscribeMarketInformation = function (webClientMessage, headerMatches, bodyObject) {
        try {
            var correlationId = bodyObject[0] * 1,
                returnCode = bodyObject[1] * 1,
                subscriptionId = bodyObject[2] * 1,
                thisSubscription = gecPrivate._subscriptions[subscriptionId] = gecPrivate._subscriptions[subscriptionId] || {};

            thisSubscription.correlationId = correlationId;
            thisSubscription.params = gecPrivate._correlationData[correlationId];

            if (returnCode === 0) {
                var response = { correlationId: correlationId };
                if (subscriptionId != null) response.subscriptionId = subscriptionId;
                if (bodyObject[3] != null) { response.marketIds = bodyObject[3].split("~"); }

                gecPrivate._correlationData[correlationId].callbackOnSuccess.call(this, response);
            }
            else {
                gecPrivate._correlationData[correlationId].callbackOnException.call(this, new gec.AsyncException({ returnCode: returnCode, name: gec.getReturnCodeName(returnCode) }));
            }

        } catch (e) {
            throw new Error("_onSubscribeMarketInformation error:" + e.message);
            alert("_onSubscribeMarketInformation error:" + e.message);
        }
    };
    var _onMarket1 = function (webClientMessage, headerMatches, bodyObject) {
        var marketId = headerMatches[2] * 1,
            thisMarket = getOrCreateSubscribedMarket(marketId);
        thisMarket.genericId = marketId;
        thisMarket.displayOrder = bodyObject.displayOrder * 1;
        thisMarket.eventClassifierId = headerMatches[1] * 1;

        thisMarket.prototype.fireILDelegates(gecPrivate._subscribedExchangeMarketILDelegates);
    };
    var _onEvent1 = function (webClientMessage, headerMatches, bodyObject) {
        var eventId = headerMatches[1] * 1,
            thisEvent = getOrCreateSubscribedEvent(eventId);

        thisEvent.displayOrder = bodyObject.displayOrder;

        thisEvent.eventClassifierId = eventId;
        thisEvent.genericId = eventId;

        thisEvent.prototype.fireILDelegates(gecPrivate._subscribedExchangeEventILDelegates);
    };

    var _onLanguage2 = function (webClientMessage, headerMatches, bodyObject) {
        var eventId = headerMatches[1] * 1,
            thisEvent = getOrCreateSubscribedEvent(eventId);

        thisEvent.genericName = bodyObject.name;
        thisEvent.raceGrade = bodyObject.raceGrade;

        thisEvent.prototype.fireILDelegates(gecPrivate._subscribedExchangeEventILDelegates);
        thisEvent.prototype.fireDeltaDelegates({ genericName: bodyObject.name, raceGrade: bodyObject.raceGrade });
    };
    var _onLanguage4 = function (webClientMessage, headerMatches, bodyObject) {
        var eventId = headerMatches[1] * 1,
            thisEvent = getOrCreateSubscribedEvent(eventId);

        thisEvent.name = bodyObject.name;

        thisEvent.prototype.fireILDelegates(gecPrivate._subscribedExchangeEventILDelegates);
        thisEvent.prototype.fireDeltaDelegates({ name: bodyObject.name });
    };
    var _onLanguage7 = function (webClientMessage, headerMatches, bodyObject) {
        var marketId = headerMatches[1] * 1,
            thisMarket = getOrCreateSubscribedMarket(marketId);

        thisMarket.genericName = bodyObject.name;
        thisMarket.prototype.fireILDelegates(gecPrivate._subscribedExchangeMarketILDelegates);
    };

    var _onEExchangeInfo = function (webClientMessage, headerMatches, bodyObject) {
        var eventId = headerMatches[1] * 1,
            thisEvent = getOrCreateSubscribedEvent(eventId);

        thisEvent.eventClassifierId = eventId;
        thisEvent.isEnabledForMultiples = bodyObject.isEnabledForMultiples;

        thisEvent.prototype.fireILDelegates(gecPrivate._subscribedExchangeEventILDelegates);
    };
    var _onTaggedValue1 = function (webClientMessage, headerMatches, bodyObject) {
        var eventId = headerMatches[1] * 1,
            taggedName = headerMatches[2],
            thisEvent = getOrCreateSubscribedEvent(eventId);

        thisEvent.taggedValues = thisEvent.taggedValues || {};
        thisEvent.taggedValues[taggedName] = bodyObject.value;

        thisEvent.prototype.fireILDelegates(gecPrivate._subscribedExchangeEventILDelegates);

        var changes = { taggedValues: {} };
        changes.taggedValues[taggedName] = bodyObject.value;

        thisEvent.prototype.fireDeltaDelegates(changes);
    };
    var _onTaggedValue2 = function (webClientMessage, headerMatches, bodyObject) {
        var marketId = headerMatches[1] * 1,
            thisMarket = getOrCreateSubscribedMarket(marketId),
            taggedName = headerMatches[2];

        thisMarket.taggedValues = thisMarket.taggedValues || {};
        thisMarket.taggedValues[taggedName] = bodyObject.value;

        thisMarket.prototype.fireILDelegates(gecPrivate._subscribedExchangeMarketILDelegates);
        var changes = { taggedValues: {} };
        changes.taggedValues[taggedName] = bodyObject.value;

        thisMarket.prototype.fireDeltaDelegates(changes);

    };
    var _onTab = function (webClientMessage, headerMatches, bodyObject) {
        var eventId = headerMatches[1] * 1,
            tabId = headerMatches[2] * 1,
            thisEventTabs = getOrCreateSubscribedEventTabs(eventId),
            m;
        if (bodyObject.displayOrder !== undefined) {
            bodyObject.displayOrder = bodyObject.displayOrder * 1;
        }
        if (bodyObject.numberOfMarketsToExpand !== undefined) {
            bodyObject.numberOfMarketsToExpand = bodyObject.numberOfMarketsToExpand * 1;
        }
        if (bodyObject.marketIds !== undefined) {
            bodyObject.marketIds = bodyObject.marketIds.split("~");
            for (m = 0; m < bodyObject.marketIds.length; m = m + 1) {
                bodyObject.marketIds[m] = bodyObject.marketIds[m] * 1;
            }
            thisEventTabs.addTab(tabId, bodyObject);
        } else {
            thisEventTabs.removeTab(tabId);
        }

    };
    var _onLanguage14 = function (webClientMessage, headerMatches, bodyObject) {
        var eventId = headerMatches[1] * 1,
            tabId = headerMatches[2] * 1,
            thisEventTabs = getOrCreateSubscribedEventTabs(eventId);

        thisEventTabs.addTab(tabId, bodyObject);
    };

    var _onMExchangeInfo = function (webClientMessage, headerMatches, bodyObject) {
        var marketId = headerMatches[1] * 1,
            thisMarket = getOrCreateSubscribedMarket(marketId),
            hasChanges = false;

        if (((bodyObject.status != null) && (thisMarket.status != bodyObject.status)) ||
            ((bodyObject.isCurrentlyInRunning != null) && (thisMarket.isCurrentlyInRunning != bodyObject.isCurrentlyInRunning)) ||
            ((bodyObject.managedWhenInrunning != null) && (thisMarket.managedWhenInrunning != bodyObject.managedWhenInrunning)) ||
            ((bodyObject.canBeInRunning != null) && (thisMarket.canBeInRunning != bodyObject.canBeInRunning)) ||
            ((bodyObject.isEnabledForMultiples != null) && (thisMarket.isEnabledForMultiples != bodyObject.isEnabledForMultiples))) {
            hasChanges = true;
        }
        bodyObject.numberOfSelections = bodyObject.numberOfSelections * 1;
        if (bodyObject.bettingTypeId !== undefined) {
            bodyObject.bettingTypeId = bodyObject.bettingTypeId * 1;
        }

        for (var k in bodyObject) {
            thisMarket[k] = bodyObject[k];
        }
        thisMarket.marketType = thisMarket.marketType * 1;

        thisMarket.displayOrder = thisMarket.displayOrder * 1;
        thisMarket.marketId = marketId;

        if (bodyObject.bOGAvailable != undefined) {//optional
            thisMarket.bOGAvailable = bodyObject.bOGAvailable;
            hasChanges = true;
        }
        if (bodyObject.numberWinningPlaces != undefined) {//optional
            thisMarket.numberWinningPlaces = bodyObject.numberWinningPlaces * 1;
            hasChanges = true;
        }
        if (bodyObject.placeFraction != undefined) {//optional
            thisMarket.placeFraction = bodyObject.placeFraction;
            hasChanges = true;
        }

        if (bodyObject.startTime != null) {//optional
            thisMarket.startTime = bodyObject.startTime;
        }
        if (bodyObject.delayFactor != null) {//optional
            thisMarket.delayFactor = bodyObject.delayFactor * 1;
        }

        if (bodyObject.numberOfWinningSelections != null) {//optional
            thisMarket.numberOfWinningSelections = bodyObject.numberOfWinningSelections * 1;
        }
        if (bodyObject.withdrawalSequenceNumber != null) {//optional
            thisMarket.withdrawalSequenceNumber = bodyObject.withdrawalSequenceNumber * 1;
        }
        if (bodyObject.resultString != null) {//optional
            thisMarket.resultString = bodyObject.resultString;
        }
        thisMarket.prototype.fireILDelegates(gecPrivate._subscribedExchangeMarketILDelegates);

        if (!webClientMessage.isInitialTopicLoad() || hasChanges) {
            thisMarket.prototype.fireDelegates(gecPrivate._subscribedExchangeMarketILDelegates, webClientMessage, bodyObject);
        }

    };

    var _onCurrency3 = function (webClientMessage, headerMatches, bodyObject) {

        var marketId = headerMatches[1] * 1;
        var hasChanges = false;

        var thisSubscribedMatchedAmount = gecPrivate._subscribedExchangeMarketMatchedAmount[marketId] = gecPrivate._subscribedExchangeMarketMatchedAmount[marketId] || new gec.SubscribedExchangeMarketMatchedAmount();

        thisSubscribedMatchedAmount.marketId = marketId;
        if ((bodyObject.forSideAmount * 1) != thisSubscribedMatchedAmount.forSideAmount) {
            thisSubscribedMatchedAmount.forSideAmount = bodyObject.forSideAmount * 1;
            hasChanges = true;
        }
        if ((bodyObject.againstSideAmount * 1) != thisSubscribedMatchedAmount.againstSideAmount) {
            thisSubscribedMatchedAmount.againstSideAmount = bodyObject.againstSideAmount * 1;
            hasChanges = true;
        }

        thisSubscribedMatchedAmount.prototype.fireILDelegates(gecPrivate._subscribedExchangeMarketMatchedAmountILDelegate);

        if (!webClientMessage.isInitialTopicLoad() || hasChanges) {
            thisSubscribedMatchedAmount.prototype.fireDeltaDelegates(bodyObject);
        }
    };

    var _onLanguage3 = function (webClientMessage, headerMatches, bodyObject) {
        var marketId = headerMatches[1] * 1,
            thisMarket = getOrCreateSubscribedMarket(marketId),
            hasChanges = false;

        gecPrivate._subscribedExchangeMarket[marketId].name = bodyObject.name;
        if (bodyObject.description != null)//optional
            gecPrivate._subscribedExchangeMarket[marketId].description = bodyObject.description;
        if (bodyObject.marketBlurb != null)//optional
            gecPrivate._subscribedExchangeMarket[marketId].marketBlurb = bodyObject.marketBlurb;

        gecPrivate._subscribedExchangeMarket[marketId].prototype.fireILDelegates(gecPrivate._subscribedExchangeMarketILDelegates);
        if (!webClientMessage.isInitialTopicLoad() || hasChanges) {
            gecPrivate._subscribedExchangeMarket[marketId].prototype.fireDeltaDelegates(bodyObject);
        }

    };
    var _onSelection1 = function (webClientMessage, headerMatches, bodyObject) {

        var marketId = headerMatches[1] * 1;
        var selectionId = headerMatches[2] * 1;

        var thisSubscribedExchangeSelection = getOrCreateSubscribedSelection(selectionId);

        thisSubscribedExchangeSelection.displayOrder = bodyObject.displayOrder * 1;
        thisSubscribedExchangeSelection.marketId = marketId;
        if (bodyObject.selectionIcon != null)
            thisSubscribedExchangeSelection.selectionIcon = bodyObject.selectionIcon;

        thisSubscribedExchangeSelection.prototype.fireILDelegates(gecPrivate._subscribedExchangeSelectionILDelegate);
        if (!webClientMessage.isInitialTopicLoad()) {
            thisSubscribedExchangeSelection.prototype.fireDeltaDelegates(bodyObject);
        }

    };
    var _onLanguage5 = function (webClientMessage, headerMatches, bodyObject) {

        var marketId = headerMatches[1] * 1;
        var selectionId = headerMatches[2] * 1;

        var thisSubscribedExchangeSelection = gecPrivate._subscribedExchangeSelection[selectionId] = gecPrivate._subscribedExchangeSelection[selectionId] || new gec.SubscribedExchangeSelection();

        thisSubscribedExchangeSelection.name = bodyObject.name;

        thisSubscribedExchangeSelection.prototype.fireILDelegates(gecPrivate._subscribedExchangeSelectionILDelegate);
        if (!webClientMessage.isInitialTopicLoad()) {
            thisSubscribedExchangeSelection.prototype.fireDeltaDelegates(bodyObject);
        }

    };
    var _onSExchangeInfo = function (webClientMessage, headerMatches, bodyObject) {
        var selectionId = headerMatches[1] * 1;
        var thisSubscribedExchangeSelection = gecPrivate._subscribedExchangeSelection[selectionId] = gecPrivate._subscribedExchangeSelection[selectionId] || new gec.SubscribedExchangeSelection();

        for (var k in bodyObject) {
            thisSubscribedExchangeSelection[k] = bodyObject[k];
        }

        if (bodyObject.selectionId != undefined)
            thisSubscribedExchangeSelection.selectionId = bodyObject.selectionId * 1;

        if (bodyObject.selectionResetCount != undefined)
            thisSubscribedExchangeSelection.selectionResetCount = bodyObject.selectionResetCount * 1;

        if (bodyObject.status != undefined)
            thisSubscribedExchangeSelection.withdrawalFactor = bodyObject.status * 1;

        if (bodyObject.withdrawalFactor != undefined)//optional
            thisSubscribedExchangeSelection.withdrawalFactor = bodyObject.withdrawalFactor * 1;

        if (bodyObject.settledTime != undefined)//optional
            thisSubscribedExchangeSelection.settledTime = bodyObject.settledTime;

        if (bodyObject.resultString != undefined)//optional
            thisSubscribedExchangeSelection.resultString = bodyObject.resultString;

        if (bodyObject.voidPercentage != undefined)//optional
            thisSubscribedExchangeSelection.voidPercentage = bodyObject.voidPercentage;

        if (bodyObject.leftSideFactor != undefined)//optional
            thisSubscribedExchangeSelection.leftSideFactor = bodyObject.leftSideFactor;

        if (bodyObject.rightSideFactor != undefined)//optional
            thisSubscribedExchangeSelection.rightSideFactor = bodyObject.rightSideFactor;

        thisSubscribedExchangeSelection.prototype.fireILDelegates(gecPrivate._subscribedExchangeSelectionILDelegate);
        if (!webClientMessage.isInitialTopicLoad()) {
            thisSubscribedExchangeSelection.prototype.fireDeltaDelegates(bodyObject);
        }

    };
    var _onSelectionblurb = function (webClientMessage, headerMatches, bodyObject) {
        var selectionId = headerMatches[1] * 1;
        var thisSubscribedExchangeSelection = getOrCreateSubscribedSelection(selectionId);

        for (var k in bodyObject) {
            thisSubscribedExchangeSelection[k] = bodyObject[k];
        }

    };
    var _onLanguage6 = function (webClientMessage, headerMatches, bodyObject) {

        var marketId = headerMatches[1] * 1;
        var selectionId = headerMatches[2] * 1;

        var thisSubscribedExchangeSelection = getOrCreateSubscribedSelection(selectionId);

        thisSubscribedExchangeSelection.name = bodyObject.name;
        thisSubscribedExchangeSelection.selectionBlurb = bodyObject.selectionBlurb;

        thisSubscribedExchangeSelection.prototype.fireILDelegates(gecPrivate._subscribedExchangeSelectionILDelegate);
        if (!webClientMessage.isInitialTopicLoad()) {
            thisSubscribedExchangeSelection.prototype.fireDeltaDelegates(bodyObject);
        }
    };

    var _marketPrices = {};

    var _onBackLayVolumeCurrencyOddsFormat = function (webClientMessage, headerMatches, bodyObject) {

        var marketId = headerMatches[1] * 1;
        var numberBackPrices = headerMatches[2] * 1;
        var numberLayPrices = headerMatches[3] * 1;
        var marketByVolume = headerMatches[4] * 1;
        var currency = headerMatches[5];
        var priceFormatId = headerMatches[6];

        if ((_marketPrices[marketId] == null) || webClientMessage.isInitialTopicLoad()) {
            _marketPrices[marketId] = {};
        }

        for (var i in bodyObject[1]) {
            var selectionId = bodyObject[1][i].selectionId * 1;
            var selectionPriceKey = selectionId + "_" + marketByVolume + "_" + currency + "_" + priceFormatId;


            if ((gecPrivate._subscribedExchangeSelectionPrices[selectionPriceKey] == null) || webClientMessage.isInitialTopicLoad() || (_marketPrices[marketId][selectionId] == null)) {
                gecPrivate._subscribedExchangeSelectionPrices[selectionPriceKey] = new gec.SubscribedExchangeSelectionPrices();
                delete gecPrivate._subscribedExchangeSelectionIndexedPrices[selectionPriceKey];
            }

            var thisSelectionPrices = gecPrivate._subscribedExchangeSelectionPrices[selectionPriceKey];


            if ((gecPrivate._subscribedExchangeSelectionIndexedPrices[selectionPriceKey] == null) || webClientMessage.isInitialTopicLoad() || (_marketPrices[marketId][selectionId] == null)) {
                gecPrivate._subscribedExchangeSelectionIndexedPrices[selectionPriceKey] = new gec.SubscribedExchangeSelectionPrices();
                gecPrivate._subscribedExchangeSelectionIndexedPrices[selectionPriceKey].layPrices = {};
                gecPrivate._subscribedExchangeSelectionIndexedPrices[selectionPriceKey].backPrices = {};
            }

            _marketPrices[marketId][selectionId] = true; //only null on inital load

            thisSelectionPrices.selectionId = selectionId;
            thisSelectionPrices.marketId = marketId;

            for (var k in bodyObject[1][i][2]) {//backPrices
                var bPrice = bodyObject[1][i][2][k];
                var displayPrice = bPrice.displayPrice.split("/");
                displayPrice = (displayPrice.length > 1) ? displayPrice[0] / displayPrice[1] : displayPrice[0];
                var priceIndex = eval(bPrice.displayPrice); // displayPrice * 1;

                if (bPrice.stake == undefined)
                    delete gecPrivate._subscribedExchangeSelectionIndexedPrices[selectionPriceKey].backPrices[priceIndex];
                else
                    gecPrivate._subscribedExchangeSelectionIndexedPrices[selectionPriceKey].backPrices[priceIndex] = bPrice;
            }

            thisSelectionPrices.backPrices = [];
            for (var p in gecPrivate._subscribedExchangeSelectionIndexedPrices[selectionPriceKey].backPrices) {
                thisSelectionPrices.backPrices[thisSelectionPrices.backPrices.length] = gecPrivate._subscribedExchangeSelectionIndexedPrices[selectionPriceKey].backPrices[p];
            }
            thisSelectionPrices.backPrices.sort(function (a, b) {
                //check if fractional
                var aPrice = 0, bPrice = 0;
                aPrice = eval(a.displayPrice);
                bPrice = eval(b.displayPrice);

                return aPrice < bPrice ? 1 : -1;
            });

            for (k in bodyObject[1][i][3]) {//layPrices
                var displayPrice = bodyObject[1][i][3][k].displayPrice.split("/");
                displayPrice = (displayPrice.length > 1) ? displayPrice[0] / displayPrice[1] : displayPrice[0];
                var priceIndex = eval(bodyObject[1][i][3][k].displayPrice); // displayPrice * 1;
                var stake = bodyObject[1][i][3][k].stake;

                if (stake == null)
                    delete gecPrivate._subscribedExchangeSelectionIndexedPrices[selectionPriceKey].layPrices[priceIndex];
                else
                    gecPrivate._subscribedExchangeSelectionIndexedPrices[selectionPriceKey].layPrices[priceIndex] = bodyObject[1][i][3][k];
            }

            thisSelectionPrices.layPrices = [];
            for (var p in gecPrivate._subscribedExchangeSelectionIndexedPrices[selectionPriceKey].layPrices) {
                thisSelectionPrices.layPrices[thisSelectionPrices.layPrices.length] = gecPrivate._subscribedExchangeSelectionIndexedPrices[selectionPriceKey].layPrices[p];
            }

            thisSelectionPrices.layPrices.sort(function (a, b) {
                //check if fractional
                var aPrice = 0, bPrice = 0;

                aPrice = eval(a.displayPrice);
                bPrice = eval(b.displayPrice);

                return aPrice > bPrice ? 1 : -1;
            });

            gecPrivate._subscribedExchangeSelectionPrices[selectionPriceKey].prototype.fireILDelegates(gecPrivate._subscribedExchangeSelectionPricesILDelegate);

            if (!webClientMessage.isInitialTopicLoad()) {
                gecPrivate._subscribedExchangeSelectionPrices[selectionPriceKey].prototype.fireDeltaDelegates(gecPrivate._subscribedExchangeSelectionPrices[selectionPriceKey], bodyObject);
            }
        }

    };

    var _onFixedOddsMarketPrices = function (webClientMessage, headerMatches, bodyObject) {

        var marketId = headerMatches[1] * 1;

        var priceFormatId = headerMatches[2];

        for (var i in bodyObject[1]) {
            var selectionId = bodyObject[1][i].selectionId * 1;
            var selectionPriceKey = selectionId + "_" + priceFormatId;
            var price = bodyObject[1][i].price;

            if ((gecPrivate._subscribedExchangeSelectionFixedOddsPrices[selectionPriceKey] == null) || webClientMessage.isInitialTopicLoad()) {
                gecPrivate._subscribedExchangeSelectionFixedOddsPrices[selectionPriceKey] = new gec.SubscribedExchangeSelectionFixedOddsPrices();
            }

            //gecPrivate._subscribedExchangeSelectionFixedOddsPrices[selectionId] = gecPrivate._subscribedExchangeSelectionFixedOddsPrices[selectionId] || new gec.SubscribedExchangeSelectionFixedOddsPrices();
            gecPrivate._subscribedExchangeSelectionFixedOddsPrices[selectionPriceKey].selectionId = selectionId;
            gecPrivate._subscribedExchangeSelectionFixedOddsPrices[selectionPriceKey].marketId = marketId;
            gecPrivate._subscribedExchangeSelectionFixedOddsPrices[selectionPriceKey].backReferencePrice = price;
            //gecPrivate._subscribedExchangeSelectionFixedOddsPrices[selectionId].selectionId = layReferencePrice;

            gecPrivate._subscribedExchangeSelectionFixedOddsPrices[selectionPriceKey].prototype.fireILDelegates(gecPrivate._subscribedExchangeSelectionFixedOddsPricesILDelegate);

            if (!webClientMessage.isInitialTopicLoad()) {
                gecPrivate._subscribedExchangeSelectionFixedOddsPrices[selectionPriceKey].prototype.fireDeltaDelegates(gecPrivate._subscribedExchangeSelectionFixedOddsPrices[selectionPriceKey], bodyObject);
            }
        }

    };

    var _onSubscribeDetailedMarketPrices = function (webClientMessage, headerMatches, bodyObject) {
        var correlationId = bodyObject[0] * 1;
        var returnCode = bodyObject[1] * 1;
        var subscriptionId = bodyObject[2] * 1;
        var marketIds = bodyObject[3];

        gecPrivate.removeFromPushMessages(correlationId);

        if (gecPrivate._subscriptions[subscriptionId] == null)
            gecPrivate._subscriptions[subscriptionId] = {};

        gecPrivate._subscriptions[subscriptionId].correlationId = correlationId;
        gecPrivate._subscriptions[subscriptionId].params = gecPrivate._correlationData[correlationId];

        if (returnCode == 0) {
            gecPrivate._correlationData[correlationId].callbackOnSuccess.call(this, { correlationId: correlationId, marketIds: marketIds, subscriptionId: subscriptionId });
        }
        else {
            if (returnCode == null)
                returnCode = 2;
            gecPrivate._correlationData[correlationId].callbackOnException.call(this, new gec.AsyncException({ returnCode: returnCode, name: gec.getReturnCodeName(returnCode) }));
        }

    };
    var _onSubscribeFixedOddsMarketPrices = function (webClientMessage, headerMatches, bodyObject) {

        var correlationId = bodyObject[0] * 1;
        var returnCode = bodyObject[1] * 1;
        var subscriptionId = bodyObject[2] * 1;
        var marketIds = bodyObject[3];

        gecPrivate.removeFromPushMessages(correlationId);

        if (gecPrivate._subscriptions[subscriptionId] == null)
            gecPrivate._subscriptions[subscriptionId] = {};

        gecPrivate._subscriptions[subscriptionId].correlationId = correlationId;
        gecPrivate._subscriptions[subscriptionId].params = gecPrivate._correlationData[correlationId];

        if (returnCode == 0) {
            gecPrivate._correlationData[correlationId].callbackOnSuccess.call(this, { correlationId: correlationId, marketIds: marketIds, subscriptionId: subscriptionId });
        }
        else {
            if (returnCode == null)
                returnCode = 2;
            gecPrivate._correlationData[correlationId].callbackOnException.call(this, new gec.AsyncException({ returnCode: returnCode, name: gec.getReturnCodeName(returnCode) }));
        }
    };
    var _onSubscribeEventHierarchy = function (webClientMessage, headerMatches, bodyObject) {
        if (bodyObject.returnCode == 0) {
            gecPrivate._correlationData[bodyObject.correlationId * 1].callbackOnSuccess.call(this, { correlationId: bodyObject.correlationId, subscriptionId: bodyObject.subscriptionId });
        }
        else {
            gecPrivate._correlationData[bodyObject.correlationId * 1].callbackOnException.call(this, new gec.AsyncException({ returnCode: bodyObject.returnCode || 2, name: gec.getReturnCodeName(bodyObject.returnCode) }));
        }
    };
    var _onSubscribeCustomHierarchy = function (webClientMessage, headerMatches, bodyObject) {
        alert("_onSubscribeCustomHierarchy");
    };
    var _onSubscribeSelectionMatchedAmounts = function (webClientMessage, headerMatches, bodyObject) {
        alert("_onSubscribeSelectionMatchedAmounts");
    };
    var _onSubscribeMarketMatchedAmounts = function (webClientMessage, headerMatches, bodyObject) {
        var correlationId = bodyObject[0] * 1;
        var returnCode = bodyObject[1] * 1;
        var subscriptionId = bodyObject[2] * 1;
        var marketIds = bodyObject[3];

        gecPrivate.removeFromPushMessages(correlationId);

        if (returnCode == 0) {
            gecPrivate._correlationData[correlationId].callbackOnSuccess.call(this, { correlationId: correlationId, marketIds: marketIds, subscriptionId: subscriptionId });
        }
        else {
            if (returnCode == null)
                returnCode = 2;
            gecPrivate._correlationData[correlationId].callbackOnException.call(this, new gec.AsyncException({ returnCode: returnCode, name: gec.getReturnCodeName(returnCode) }));
        }
    };
    var _onSubscribeEventMatchedAmounts = function (webClientMessage, headerMatches, bodyObject) {
        alert("_onSubscribeEventMatchedAmounts");
    };

    gec.Controller.prototype.subscribeCustomHierarchy = function (params) {
        var correlationId = gecPrivate.addToCorrelation(params);


        var request = {};
        request[0] = correlationId;

        if (params.eventClassifierId != null) {
            request[2] = params.eventClassifierId;
        }

        request[3] = params.wantDirectDescendentsOnly;
        request[4] = params.wantSelectionInformation;
        request[5] = params.fetchOnly;

        if (gecPrivate._debug) { gecPrivate._base.log("subscribeCustomHierarchy"); }
        gecPrivate._sendStreamingMessage(63, request);
        return correlationId;
    };
    gec.Controller.prototype.subscribeDetailedMarketPrices = function (params) {
        var correlationId = gecPrivate.addToCorrelation(params);

        var request = {};
        request[0] = correlationId;

        if (params.eventClassifierId != null) {
            request[1] = params.eventClassifierId;

            if (params.marketTypesToExclude != null) {
                request[2] = "";

                for (var excludeI = 0; excludeI < params.marketTypesToExclude.length; excludeI++) {
                    request[2] += params.marketTypesToExclude[excludeI] + "~";
                }
                request[2] = request[2].substr(0, request[2].length - 1);

            }
            if (params.marketTypesToInclude != null) {
                request[3] = "";

                for (var includeI = 0; includeI < params.marketTypesToInclude.length; includeI++) {
                    request[3] += params.marketTypesToInclude[includeI] + "~";
                }
                request[3] = request[3].substr(0, request[3].length - 1);
            }

            request[4] = params.wantDirectDescendentsOnly;
        } else {
            if (params.marketIds != null) {
                request[5] = "";

                for (var includeI = 0; includeI < params.marketIds.length; includeI++) {
                    request[5] += params.marketIds[includeI] + "~";
                }
                request[5] = request[5].substr(0, request[5].length - 1);
            }

        }
        request[6] = params.numberBackPrices;
        request[7] = params.numberLayPrices;
        request[8] = params.filterByVolume;
        request[11] = params.fetchOnly;

        if (gecPrivate._debug) { gecPrivate._base.log("subscribeDetailedMarketPrices"); }

        gecPrivate.addToPushMessages(request);
        gecPrivate._sendStreamingMessage(10, request);
        return correlationId;
    }


    gec.Controller.prototype.subscribeEventMatchedAmounts = function (params) {
        var correlationId = gecPrivate.addToCorrelation(params);

        var request = {};
        request[0] = correlationId;
        request[1] = params.eventClassifierId;
        request[2] = params.wantDirectDescendentsOnly;
        request[4] = params.fetchOnly;

        gecPrivate._sendStreamingMessage(15, request);
        return correlationId;
    };
    gec.Controller.prototype.subscribeItemNames = function (params) {
        var correlationId = gecPrivate.addToCorrelation(params);

        gecPrivate._sendStreamingMessage("subscribeItemNames", { 1: "en", 6: marketIdStr });

        return correlationId;
    };
    gec.Controller.prototype.subscribeMarketMatchedAmounts = function (params) {
        var correlationId = gecPrivate.addToCorrelation(params);

        var request = {};
        request[0] = correlationId;

        if (params.eventClassifierId != null) {
            request[1] = params.eventClassifierId;

            if (params.marketTypesToExclude != null) {
                request[2] = "";

                for (var excludeI = 0; excludeI < params.marketTypesToExclude.length; excludeI++) {
                    request[2] += params.marketTypesToExclude[excludeI] + "~";
                }
                request[2] = request[2].substr(0, request[2].length - 1);
            }
            if (params.marketTypesToInclude != null) {
                request[3] = "";

                for (var includeI = 0; includeI < params.marketTypesToInclude.length; includeI++) {
                    request[3] += params.marketTypesToInclude[includeI] + "~";
                }
                request[3] = request[3].substr(0, request[3].length - 1);
            }

            request[4] = params.wantDirectDescendentsOnly;
        } else {
            if (params.marketIds != null) {
                request[5] = "";

                for (var includeI = 0; includeI < params.marketIds.length; includeI++) {
                    request[5] += params.marketIds[includeI] + "~";
                }
                request[5] = request[5].substr(0, request[5].length - 1);
            }

        }
        request[7] = params.fetchOnly;

        gecPrivate.addToPushMessages(request);
        gecPrivate._sendStreamingMessage(14, request);
        return correlationId;
    };

    gec.Controller.prototype.subscribeOrders = function (params) {
        var correlationId = gecPrivate.addToCorrelation(params);

        var request = {};
        request[0] = correlationId;

        if (params.eventClassifierId != null) {
            request[1] = params.eventClassifierId;

            if (params.marketTypesToExclude != null) {
                request[2] = "";

                for (var excludeI = 0; excludeI < params.marketTypesToExclude.length; excludeI++) {
                    request[2] += params.marketTypesToExclude[excludeI] + "~";
                }
                request[2] = request[2].substr(0, request[2].length - 1);
            }
            if (params.marketTypesToInclude != null) {
                request[3] = "";

                for (var includeI = 0; includeI < params.marketTypesToInclude.length; includeI++) {
                    request[3] += params.marketTypesToInclude[includeI] + "~";
                }
                request[3] = request[3].substr(0, request[3].length - 1);
            }

            request[4] = params.wantDirectDescendentsOnly;
        } else {
            if (params.marketIds != null) {
                request[5] = "";

                for (var includeI = 0; includeI < params.marketIds.length; includeI++) {
                    request[5] += params.marketIds[includeI] + "~";
                }
                request[5] = request[5].substr(0, request[5].length - 1);
            }

        }
        request[8] = params.fetchOnly;

        gecPrivate._sendStreamingMessage(10, request);
        alert("subscribeOrders");
        return correlationId;
    };
    gec.Controller.prototype.subscribePAndLs = function (params) {
        var correlationId = gecPrivate.addToCorrelation(params);

        var request = {};
        request[0] = correlationId;

        if (params.eventClassifierId != null) {
            request[1] = params.eventClassifierId;

            if (params.marketTypesToExclude != null) {
                request[2] = "";

                for (var excludeI = 0; excludeI < params.marketTypesToExclude.length; excludeI++) {
                    request[2] += params.marketTypesToExclude[excludeI] + "~";
                }
                request[2] = request[2].substr(0, request[2].length - 1);
            }
            if (params.marketTypesToInclude != null) {
                request[3] = "";

                for (var includeI = 0; includeI < params.marketTypesToInclude.length; includeI++) {
                    request[3] += params.marketTypesToInclude[includeI] + "~";
                }
                request[3] = request[3].substr(0, request[3].length - 1);
            }

            request[4] = params.wantDirectDescendentsOnly;
        } else {
            if (params.marketIds != null) {
                request[5] = "";

                for (var includeI = 0; includeI < params.marketIds.length; includeI++) {
                    request[5] += params.marketIds[includeI] + "~";
                }
                request[5] = request[5].substr(0, request[5].length - 1);
            }

        }
        request[8] = params.fetchOnly;

        gecPrivate._sendStreamingMessage(10, request);
        alert("subscribePAndLs");
        return correlationId;
    };

    gec.Controller.prototype.subscribePriceHistories = function (params) {
        var correlationId = gecPrivate.addToCorrelation(params);

        var request = {};
        request[0] = correlationId;

        if (params.eventClassifierId != null) {
            request[1] = params.eventClassifierId;

            if (params.marketTypesToExclude != null) {
                request[2] = "";

                for (var excludeI = 0; excludeI < params.marketTypesToExclude.length; excludeI++) {
                    request[2] += params.marketTypesToExclude[excludeI] + "~";
                }
                request[2] = request[2].substr(0, request[2].length - 1);
            }
            if (params.marketTypesToInclude != null) {
                request[3] = "";

                for (var includeI = 0; includeI < params.marketTypesToInclude.length; includeI++) {
                    request[3] += params.marketTypesToInclude[includeI] + "~";
                }
                request[3] = request[3].substr(0, request[3].length - 1);
            }

            request[4] = params.wantDirectDescendentsOnly;
        } else {
            if (params.marketIds != null) {
                request[5] = "";

                for (var includeI = 0; includeI < params.marketIds.length; includeI++) {
                    request[5] += params.marketIds[includeI] + "~";
                }
                request[5] = request[5].substr(0, request[5].length - 1);
            }

        }
        if (params.from != null)
            request[7] = params.from;
        if (params.to != null)
            request[8] = params.to;

        request[9] = params.granularity;
        request[10] = params.fetchOnly;

        gecPrivate._sendStreamingMessage(19, request);
        alert("subscribePriceHistories");
        return correlationId;
    };

    gec.Controller.prototype.subscribeSelectionMatchedAmounts = function (params) {
        var correlationId = gecPrivate.addToCorrelation(params);

        var request = {};
        request[0] = correlationId;

        if (params.eventClassifierId != null) {
            request[1] = params.eventClassifierId;

            if (params.marketTypesToExclude != null) {
                request[2] = ""

                for (var excludeI = 0; excludeI < params.marketTypesToExclude.length; excludeI++) {
                    request[2] += params.marketTypesToExclude[excludeI] + "~";
                }
                request[2] = request[2].substr(0, request[2].length - 1);
            }
            if (params.marketTypesToInclude != null) {
                request[3] = ""

                for (var includeI = 0; includeI < params.marketTypesToInclude.length; includeI++) {
                    request[3] += params.marketTypesToInclude[includeI] + "~";
                }
                request[3] = request[3].substr(0, request[3].length - 1);
            }

            request[4] = params.wantDirectDescendentsOnly;
        } else {
            if (params.marketIds != null) {
                request[5] = ""

                for (includeI in params.marketIds) {
                    request[5] += params.marketIds[includeI] + "~";
                }
                request[5] = request[5].substr(0, request[5].length - 1);
            }

        }
        request[7] = params.fetchOnly;

        gecPrivate._sendStreamingMessage(13, request);
        return correlationId;
    };
    gec.Controller.prototype.subscribeFixedOddsMarketPrices = function (params) {
        var correlationId = gecPrivate.addToCorrelation(params);

        var request = {};
        request[0] = correlationId;

        if (params.eventClassifierId != null) {
            request[1] = params.eventClassifierId;

            if (params.marketTypesToExclude != null) {
                request[2] = ""

                for (var excludeI = 0; excludeI < params.marketTypesToExclude.length; excludeI++) {
                    request[2] += params.marketTypesToExclude[excludeI] + "~";
                }
                request[2] = request[2].substr(0, request[2].length - 1);
            }
            if (params.marketTypesToInclude != null) {
                request[3] = ""

                for (var includeI = 0; includeI < params.marketTypesToInclude.length; includeI++) {
                    request[3] += params.marketTypesToInclude[includeI] + "~";
                }
                request[3] = request[3].substr(0, request[3].length - 1);
            }

            request[4] = params.wantDirectDescendentsOnly;
        } else {
            if (params.marketIds != null) {
                request[5] = ""

                for (var includeI = 0; includeI < params.marketIds.length; includeI++) {
                    request[5] += params.marketIds[includeI] + "~";
                }
                request[5] = request[5].substr(0, request[5].length - 1);
            }

        }
        request[8] = params.fetchOnly;

        gecPrivate._sendStreamingMessage(11, request);
        return correlationId;
    };
    gec.Controller.prototype.subscribeTrades = function (params) {
        var correlationId = gecPrivate.addToCorrelation(params);

        var request = {};
        request[0] = correlationId;

        if (params.eventClassifierId != null) {
            request[1] = params.eventClassifierId;

            if (params.marketTypesToExclude != null) {
                request[2] = ""

                for (var excludeI = 0; excludeI < params.marketTypesToExclude.length; excludeI++) {
                    request[2] += params.marketTypesToExclude[excludeI] + "~";
                }
                request[2] = request[2].substr(0, request[2].length - 1);
            }
            if (params.marketTypesToInclude != null) {
                request[3] = ""

                for (var includeI = 0; includeI < params.marketTypesToInclude.length; includeI++) {
                    request[3] += params.marketTypesToInclude[includeI] + "~";
                }
                request[3] = request[3].substr(0, request[3].length - 1);
            }

            request[4] = params.wantDirectDescendentsOnly;
        } else {
            if (params.marketIds != null) {
                request[5] = ""

                for (var includeI = 0; includeI < params.marketIds.length; includeI++) {
                    request[5] += params.marketIds[includeI] + "~";
                }
                request[5] = request[5].substr(0, request[5].length - 1);
            }

        }
        if (params.filterAmount != null)
            request[7] = params.filterAmount;
        if (params.tradesFrom != null)
            request[8] = params.tradesFrom;

        request[9] = params.fetchOnly;

        gecPrivate._sendStreamingMessage(18, request);
        return correlationId;
    };

    gec.Controller.prototype.getEventTab = function (eventId) {
        return subscribedExchangeEventTabs[eventId] || exchangeEventTabs[eventId];
    };
    gec.Controller.prototype.deleteEventTab = function (eventId) {
        delete subscribedExchangeEventTabs[eventId];
        delete exchangeEventTabs[eventId];
    };

    /****************************
    loadLocalOrderCache
    ****************************/
    gec.Controller.prototype.loadLocalOrderCache = function (params) {
        gecPrivate._bootstrapFailedAttempts = 0;
        gecPrivate._thisController._listBootStrapOrders(params);
    };

    gec.Controller.prototype._listBootStrapOrders = function (params) {
        if (gecPrivate.userContext == null) {
            params.callbackOnException.call(this, { returnCode: 590 });
        }
        else {
            var request = new gec.IAPIRequest(params);
            request.sessionToken = gecPrivate.sessionToken;
            request.callbackOnILCompletion = params.callbackOnILCompletion;

            request.sequenceNumber = gecPrivate._maxSequenceNo;
            request.wantSettledOrdersOnUnsettledMarkets = true;
            this.sendRequest("/ListBootstrapOrders.ashx", request, _loadLocalOrderCacheResponse);
        }
    };
    var _loadLocalOrderCacheResponse = function (request, response) {
        if (gecPrivate._orderCache == null) gecPrivate._orderCache = {};

        if (response.returnCode != 0) {
            gecPrivate._bootstrapFailedAttempts = gecPrivate._bootstrapFailedAttempts + 1;

            if (gecPrivate._bootstrapFailedAttempts <= gecPrivate._maxBootstrapFailedAttempts) {
                //gecPrivate._thisController.loadLocalOrderCache(request);
                gecPrivate._thisController._listBootStrapOrders(request);
            } else {
                gecPrivate.checkExpiredSession(response.returnCode);
                request.callbackOnException.call(this, { returnCode: response.returnCode });
            }

        }
        else {
            if (response.orders != null) {

                for (var i = 0; i < response.orders.length; i++) {
                    if (response.orders[i].status === 5) {
                        continue; //ignore voided bets
                    }
                    response.orders[i].polarityId = response.orders[i].polarity;

                    gecPrivate._orderCache[response.orders[i].orderId] = new gec.Order(response.orders[i]);
                    var orderCacheObject = gecPrivate._orderCache[response.orders[i].orderId];

                    var thisOrder = response.orders[i];

                    (function (thisOrder, orderCacheObject) {
                        orderCacheObject.orderId = thisOrder.orderId;

                        orderCacheObject.eventClassifierFullName = function () {
                            return thisOrder.eventClassifierFullName || thisOrder.eventClassifierName;
                        };

                        orderCacheObject.marketId = function () { return thisOrder.marketId; };
                        orderCacheObject.marketTypeId = function () { return thisOrder.marketType; };

                        orderCacheObject.punterReferenceNumber = thisOrder.pnterReferenceNumber;
                        orderCacheObject.placePayout = function () { return thisOrder.placePayout; };

                        orderCacheObject.marketName = function () { return thisOrder.marketName; };
                        orderCacheObject.selectionId = function () { return thisOrder.selectionId; };
                        orderCacheObject.selectionName = function () {
                            return thisOrder.selectionName;
                        };
                        orderCacheObject.eventClassifierId = function () {
                            if (thisOrder.eventClassifierId !== undefined) {
                                return thisOrder.eventClassifierId;
                            }
                            if (gecPrivate._markets[thisOrder.marketId] != null) {
                                return gecPrivate._markets[thisOrder.marketId].getEventClassifier().eventClassifierId;
                            }

                            return undefined;
                        };

                        orderCacheObject.orderStatusId = thisOrder.status;

                        orderCacheObject.issuedAt = thisOrder.issuedAt;

                        orderCacheObject.expectedSelectionResetCount = thisOrder.expectedSelectionResetCount;
                        orderCacheObject.expectedWithdrawalSequenceNumber = thisOrder.expectedWithdrawalSequenceNumber;

                        // orderCacheObject.lastChangedAt = thisOrder.eventClassifierName;
                        orderCacheObject.expiresAt = thisOrder.expiresAt;
                        // orderCacheObject.marketTypeId = thisOrder.eventClassifierName;
                        // orderCacheObject.marketStatusId = thisOrder.eventClassifierName;
                        orderCacheObject.requestedStake = thisOrder.matchedStake.amount + thisOrder.unmatchedStake.amount;
                        orderCacheObject.requestedPrice = thisOrder.requestedPrice;
                        //orderCacheObject.requestedAveragePrice = thisOrder.eventClassifierName;
                        //orderCacheObject.expectedSelectionResetCount = thisOrder.eventClassifierName;
                        //orderCacheObject.expectedWithdrawalSequenceNumber = thisOrder.eventClassifierName;

                        orderCacheObject.unmatchedStake = thisOrder.unmatchedStake.amount;
                        orderCacheObject.averageMatchedPrice = thisOrder.matchedPrice;
                        orderCacheObject.matchedStake = thisOrder.matchedStake.amount;
                        orderCacheObject.matchedAgainstStake = thisOrder.matchedAgainstStake.amount;
                        orderCacheObject.isFreeBet = thisOrder.isFreeBet;

                        orderCacheObject.polarityId = thisOrder.polarity;
                        orderCacheObject.cancelOnInRunning = thisOrder.cancelOnInRunning;
                        orderCacheObject.cancelIfSelectionReset = thisOrder.cancelIfSelectionReset;
                        orderCacheObject.sequenceNumber = thisOrder.sequenceNumber;

                        orderCacheObject.isCurrentlyInRunning = thisOrder.isCurrentlyInRunning;
                        orderCacheObject.willBeInRunning = thisOrder.willBeInRunning;


                        orderCacheObject.totalForSideMakeStake = thisOrder.totalForSideMakeStake.amount;
                        orderCacheObject.totalForSideTakeStake = thisOrder.totalForSideTakeStake.amount;
                        orderCacheObject.makeCommissionRate = thisOrder.makeCommissionRate;
                        orderCacheObject.takeCommissionRate = thisOrder.takeCommissionRate;
                        if (thisOrder.orderFillType)
                            orderCacheObject.orderFillType = thisOrder.orderFillType;


                        if (thisOrder.orderPAndL != null)
                            orderCacheObject.orderPAndL = thisOrder.orderPAndL.amount;

                    })(thisOrder, orderCacheObject);

                }
                gecPrivate._maxSequenceNo = response.orders[response.orders.length - 1].sequenceNumber;
                if (gecPrivate._maxSequenceNo < response.maximumSequenceNumber) {//if more to load
                    //gecPrivate._thisController.loadLocalOrderCache(request);
                    gecPrivate._thisController._listBootStrapOrders(request);
                }
                else {//orders full loaded
                    gecPrivate._maxSequenceNo = response.maximumSequenceNumber;
                    // Only create the interval if one doesn't already exist
                    gecPrivate._orderCacheInterval = gecPrivate._orderCacheInterval || window.setTimeout(function () { _listOrdersChangedSince(request) }, gecPrivate.pollChangedOrdersTime);


                    request.callbackOnSuccess.call(this);

                    request.callbackOnILCompletion.call(this);
                    delete request.callbackOnILCompletion;
                }
            }
            else {//orders was null
                gecPrivate._maxSequenceNo = response.maximumSequenceNumber || 0;
                if (request.callbackOnILCompletion != null)
                    request.callbackOnILCompletion.call(this);

                // Only create the interval if one doesn't already exist
                gecPrivate._orderCacheInterval = gecPrivate._orderCacheInterval || window.setTimeout(function () { _listOrdersChangedSince(request) }, gecPrivate.pollChangedOrdersTime);
                request.callbackOnSuccess.call(this);
            }
        }
    };

    /****************************
    listOrdersChangedSince
    ****************************/
    var _listOrdersChangedSince = function (params) {
        var request = new gec.IAPIRequest(params);
        if (gecPrivate.sessionToken === undefined) {
            return;
        }
        request.sessionToken = gecPrivate.sessionToken;
        request.sequenceNumber = gecPrivate._maxSequenceNo;
        gecPrivate._thisController.sendRequest("/ListOrdersChangedSince.ashx", request, _listOrdersChangedSinceResponse, listOrdersChangedSinceXHR);
    };

    var _listOrdersChangedSinceResponse = function (request, response) {
        window.clearTimeout(gecPrivate._orderCacheInterval)

        gecPrivate._orderCacheInterval = window.setTimeout(function () {
            _listOrdersChangedSince(request);
        }, gecPrivate.pollChangedOrdersTime);

        var structuralChange = false;
        if (gecPrivate.userContext != null) {
            var unknownMarketIds = {};
            var needMarketInformation = false; //used to call listExchangeMarketInformation
            var context = this;
            if (response.returnCode != 0) {
                gecPrivate.checkExpiredSession(response.returnCode);
            }
            if ((response.returnCode == 0) && (response.orders != null)) {
                for (var orderi = 0; orderi < response.orders.length; orderi++) {

                    if (gecPrivate._orderCache == null) gecPrivate._orderCache = {};
                    if ((response.orders[orderi].status == 3) && (response.orders[orderi].matchedStake.amount == 0))//cancelled
                    {
                        structuralChange = true;


                        if ((gecPrivate._orderCache[response.orders[orderi].orderId] != null) && (gecPrivate._orderCache[response.orders[orderi].orderId].fireOnChange != null))
                            gecPrivate._orderCache[response.orders[orderi].orderId].fireOnChange.call(null, { orderId: response.orders[orderi].orderId, order: null });

                        gecPrivate._orderCache[response.orders[orderi].orderId] = null;
                        delete gecPrivate._orderCache[response.orders[orderi].orderId];

                        _deletedOrderIds[response.orders[orderi].orderId] = true;
                    }
                    else
                        if (response.orders[orderi].status == 5)//cancelled or voided
                        {
                            structuralChange = true;

                            if ((gecPrivate._orderCache[response.orders[orderi].orderId] != null) && (gecPrivate._orderCache[response.orders[orderi].orderId].fireOnChange != null))
                                gecPrivate._orderCache[response.orders[orderi].orderId].fireOnChange.call(null, { orderId: response.orders[orderi].orderId, order: null });

                            gecPrivate._orderCache[response.orders[orderi].orderId] = null;
                            delete gecPrivate._orderCache[response.orders[orderi].orderId];
                            _deletedOrderIds[response.orders[orderi].orderId] = true;
                        }
                        else {

                            if (gecPrivate._orderCache[response.orders[orderi].orderId] == null) {
                                structuralChange = true;

                                if (gecPrivate._selections[response.orders[orderi].selectionId] == null) {
                                    gecPrivate._selections[response.orders[orderi].selectionId] = {};
                                    gecPrivate._selections[response.orders[orderi].selectionId].selectionName = "...";

                                    unknownMarketIds[response.orders[orderi].marketId] = response.orders[orderi].marketId;
                                    needMarketInformation = true;
                                }

                                if (gecPrivate._markets[response.orders[orderi].marketId] == null) {
                                    gecPrivate._markets[response.orders[orderi].marketId] = {};
                                    gecPrivate._markets[response.orders[orderi].marketId].marketName = response.orders[orderi].marketName || "...";
                                    gecPrivate._markets[response.orders[orderi].marketId].eventClassifier = {};
                                    gecPrivate._markets[response.orders[orderi].marketId].eventClassifier.eventClassifierFullName = response.orders[orderi].eventClassifierFullName;
                                    gecPrivate._markets[response.orders[orderi].marketId].eventClassifier.eventClassifierName = gecPrivate._base.getEventName(response.orders[orderi].eventClassifierFullName);
                                    gecPrivate._markets[response.orders[orderi].marketId].getEventClassifier = function () {

                                        try {
                                            return gecPrivate._markets[response.orders[orderi].marketId].eventClassifier;
                                        } catch (ex) {
                                            console.warn("unkown marketId on order:", response.orders[orderi]);
                                        }
                                    }

                                    unknownMarketIds[response.orders[orderi].marketId] = response.orders[orderi].marketId;
                                    needMarketInformation = true;
                                }

                                response.orders[orderi].selectionName = gecPrivate._selections[response.orders[orderi].selectionId].selectionName;
                                response.orders[orderi].marketName = gecPrivate._markets[response.orders[orderi].marketId].marketName;
                                //response.orders[orderi].eventClassifierFullName = _markets[response.orders[orderi].marketId].eventClassifier.eventClassifierFullName;

                                gecPrivate._orderCache[response.orders[orderi].orderId] = new gec.Order(response.orders[orderi]);

                                var thisOrderForced = response.orders[orderi];

                                (function (thisOrderForced) {
                                    gecPrivate._orderCache[thisOrderForced.orderId].selectionName = function () {
                                        return gecPrivate._selections[thisOrderForced.selectionId].selectionName;
                                    };
                                    gecPrivate._orderCache[thisOrderForced.orderId].marketName = function () {
                                        return gecPrivate._markets[thisOrderForced.marketId].marketName;
                                    };

                                    gecPrivate._orderCache[thisOrderForced.orderId].marketTypeId = function () { return thisOrderForced.marketType; };

                                    gecPrivate._orderCache[thisOrderForced.orderId].punterReferenceNumber = thisOrderForced.pnterReferenceNumber;
                                    gecPrivate._orderCache[thisOrderForced.orderId].placePayout = function () { return thisOrderForced.placePayout; };

                                    gecPrivate._orderCache[thisOrderForced.orderId].eventClassifierFullName = function () {

                                        try {
                                            return thisOrderForced.eventClassifierFullName || gecPrivate._markets[thisOrderForced.marketId].eventClassifier.eventClassifierName || gecPrivate._markets[thisOrderForced.marketId].getEventClassifier().eventClassifierName;
                                        } catch (ex) {
                                            console.warn("unknown marketId on order forced:", thisOrderForced.marketId);
                                            return "Unknown event";
                                        }
                                    };

                                    gecPrivate._orderCache[thisOrderForced.orderId].eventClassifierId = function () {
                                        try {
                                            return thisOrderForced.eventClassifierId || gecPrivate._markets[thisOrderForced.marketId].getEventClassifier().eventClassifierId;
                                        } catch (ex) {
                                            console.warn("unknown marketId on order forced:", thisOrderForced.marketId);
                                        }
                                    }

                                })(thisOrderForced);
                            }

                            gecPrivate._orderCache[response.orders[orderi].orderId].orderId = response.orders[orderi].orderId;
                            gecPrivate._orderCache[response.orders[orderi].orderId].orderStatusId = response.orders[orderi].status;
                            gecPrivate._orderCache[response.orders[orderi].orderId].issuedAt = response.orders[orderi].issuedAt;
                            gecPrivate._orderCache[response.orders[orderi].orderId].expiresAt = response.orders[orderi].expiresAt;
                            gecPrivate._orderCache[response.orders[orderi].orderId].requestedStake = response.orders[orderi].matchedStake.amount + response.orders[orderi].unmatchedStake.amount;
                            gecPrivate._orderCache[response.orders[orderi].orderId].requestedPrice = response.orders[orderi].requestedPrice;
                            gecPrivate._orderCache[response.orders[orderi].orderId].isFreeBet = response.orders[orderi].isFreeBet;

                            if (response.orders[orderi].matchedStake.amount >= gecPrivate._orderCache[response.orders[orderi].orderId].matchedStake) {
                                gecPrivate._orderCache[response.orders[orderi].orderId].matchedStake = response.orders[orderi].matchedStake.amount;
                                gecPrivate._orderCache[response.orders[orderi].orderId].unmatchedStake = response.orders[orderi].unmatchedStake.amount;
                                gecPrivate._orderCache[response.orders[orderi].orderId].averageMatchedPrice = response.orders[orderi].matchedPrice;
                            }

                            gecPrivate._orderCache[response.orders[orderi].orderId].expectedSelectionResetCount = response.orders[orderi].expectedSelectionResetCount;
                            gecPrivate._orderCache[response.orders[orderi].orderId].expectedWithdrawalSequenceNumber = response.orders[orderi].expectedWithdrawalSequenceNumber;

                            gecPrivate._orderCache[response.orders[orderi].orderId].polarityId = response.orders[orderi].polarity ? 1 : 2;
                            gecPrivate._orderCache[response.orders[orderi].orderId].cancelOnInRunning = response.orders[orderi].cancelOnInRunning;
                            gecPrivate._orderCache[response.orders[orderi].orderId].cancelIfSelectionReset = response.orders[orderi].cancelIfSelectionReset;
                            gecPrivate._orderCache[response.orders[orderi].orderId].sequenceNumber = response.orders[orderi].sequenceNumber;

                            if (response.orders[orderi].totalForSideMakeStake != null)
                                gecPrivate._orderCache[response.orders[orderi].orderId].totalForSideMakeStake = response.orders[orderi].totalForSideMakeStake.amount;
                            if (response.orders[orderi].totalForSideTakeStake != null)
                                gecPrivate._orderCache[response.orders[orderi].orderId].totalForSideTakeStake = response.orders[orderi].totalForSideTakeStake.amount;
                            gecPrivate._orderCache[response.orders[orderi].orderId].requestedPrice = response.orders[orderi].requestedPrice;
                            gecPrivate._orderCache[response.orders[orderi].orderId].requestedAveragePrice = response.orders[orderi].requestedAveragePrice;
                            gecPrivate._orderCache[response.orders[orderi].orderId].matchedPrice = response.orders[orderi].matchedPrice;

                            if (response.orders[orderi].provisionalMatchedStake != null)
                                gecPrivate._orderCache[response.orders[orderi].orderId].provisionalMatchedStake = response.orders[orderi].provisionalMatchedStake.amount;
                            if (response.orders[orderi].matchedAgainstStake != null)
                                gecPrivate._orderCache[response.orders[orderi].orderId].matchedAgainstStake = response.orders[orderi].matchedAgainstStake.amount;
                            if (response.orders[orderi].provisionalMatchedAgainstStake != null)
                                gecPrivate._orderCache[response.orders[orderi].orderId].provisionalMatchedAgainstStake = response.orders[orderi].provisionalMatchedAgainstStake.amount;

                            gecPrivate._orderCache[response.orders[orderi].orderId].expectedSelectionResetCount = response.orders[orderi].expectedSelectionResetCount;
                            gecPrivate._orderCache[response.orders[orderi].orderId].expectedWithdrawalSequenceNumber = response.orders[orderi].expectedWithdrawalSequenceNumber;
                            gecPrivate._orderCache[response.orders[orderi].orderId].orderStatusId = response.orders[orderi].status;
                            gecPrivate._orderCache[response.orders[orderi].orderId].expiresAt = response.orders[orderi].expiresAt;
                            gecPrivate._orderCache[response.orders[orderi].orderId].cancelOnInRunning = response.orders[orderi].cancelOnInRunning;
                            gecPrivate._orderCache[response.orders[orderi].orderId].cancelIfSelectionReset = response.orders[orderi].cancelIfSelectionReset;
                            gecPrivate._orderCache[response.orders[orderi].orderId].isCurrentlyInRunning = response.orders[orderi].isCurrentlyInRunning;
                            gecPrivate._orderCache[response.orders[orderi].orderId].isMarketConfused = response.orders[orderi].isMarketConfused;
                            gecPrivate._orderCache[response.orders[orderi].orderId].commissionBasis = response.orders[orderi].commissionBasis;
                            gecPrivate._orderCache[response.orders[orderi].orderId].makeCommissionRate = response.orders[orderi].makeCommissionRate;
                            gecPrivate._orderCache[response.orders[orderi].orderId].takeCommissionRate = response.orders[orderi].takeCommissionRate;
                            if (response.orders[orderi].orderFillType)
                                gecPrivate._orderCache[response.orders[orderi].orderId].orderFillType = response.orders[orderi].orderFillType;

                            gecPrivate._orderCache[response.orders[orderi].orderId].isCurrentlyInRunning = response.orders[orderi].isCurrentlyInRunning;
                            gecPrivate._orderCache[response.orders[orderi].orderId].willBeInRunning = response.orders[orderi].willBeInRunning;

                            if (response.orders[orderi].orderPAndL != null)
                                gecPrivate._orderCache[response.orders[orderi].orderId].orderPAndL = orderPAndL.amount;
                            if (response.orders[orderi].taxAmountDeducted != null)
                                gecPrivate._orderCache[response.orders[orderi].orderId].taxAmountDeducted = taxAmountDeducted.amount;
                            if (response.orders[orderi].orderCommission != null)
                                gecPrivate._orderCache[response.orders[orderi].orderId].orderCommission = orderCommission.amount;

                            if (gecPrivate._orderCache[response.orders[orderi].orderId].fireOnChange != null)
                                gecPrivate._orderCache[response.orders[orderi].orderId].fireOnChange.call(null, { orderId: response.orders[orderi].orderId, order: gecPrivate._orderCache[response.orders[orderi].orderId] });
                        }
                }
                gecPrivate._maxSequenceNo = response.orders[response.orders.length - 1].sequenceNumber;
            }
            if (structuralChange)
                _processFireOnChange();

            if (needMarketInformation) {
                var marketIds = [];
                for (marketI in unknownMarketIds) {
                    marketIds[marketIds.length] = unknownMarketIds[marketI];
                }
                gecPrivate._thisController.getExchangePrices({
                    callbackOnSuccess: function (markets) {

                        for (var marketI = 0; marketI < markets.length; marketI++) {
                            if (gecPrivate._eventClassifiers[markets[marketI].eventClassifierId] == null) {
                                gecPrivate._eventClassifiers[markets[marketI].eventClassifierId] = {};
                                if (markets[marketI].eventClassifierFullName == null) markets[marketI].eventClassifierFullName = "unknown";
                            }
                            gecPrivate._eventClassifiers[markets[marketI].eventClassifierId].eventClassifierId = markets[marketI].eventClassifierId;
                            gecPrivate._eventClassifiers[markets[marketI].eventClassifierId].eventClassifierFullName = markets[marketI].eventClassifierFullName;
                            gecPrivate._eventClassifiers[markets[marketI].eventClassifierId].eventClassifierName = gecPrivate._base.getEventName(markets[marketI].eventClassifierFullName);

                            if (gecPrivate._markets[markets[marketI].marketId] == null) {
                                gecPrivate._markets[markets[marketI].marketId] = {};
                            }
                            gecPrivate._markets[markets[marketI].marketId].marketId = markets[marketI].marketId;
                            gecPrivate._markets[markets[marketI].marketId].marketName = markets[marketI].marketName;
                            gecPrivate._markets[markets[marketI].marketId].eventClassifier = gecPrivate._eventClassifiers[markets[marketI].eventClassifierId];

                            if (gecPrivate._markets[markets[marketI].marketId].selections == null) {
                                gecPrivate._markets[markets[marketI].marketId].selections = markets[marketI].selections;
                            }

                            for (var selectionI = 0; selectionI < markets[marketI].selections.length; selectionI++) {
                                if (gecPrivate._selections[markets[marketI].selections[selectionI].selectionId] == null) {
                                    gecPrivate._selections[markets[marketI].selections[selectionI].selectionId] = {};
                                }
                                gecPrivate._selections[markets[marketI].selections[selectionI].selectionId].selectionName = markets[marketI].selections[selectionI].selectionName;
                            }
                        }


                    },
                    callbackOnException: function () { },
                    marketIds: marketIds,
                    markets: null,
                    eventClassifierId: null,
                    marketTypeId: null,
                    playMarkets: false,
                    eventClassifier: null,
                    wantIcons: false,
                    justRefreshPrices: false,
                    thresholdAmount: 1,
                    numberForPricesRequired: 0,
                    numberAgainstPricesRequired: 0
                });
            }

        }
    };

    /****************************
    forceLocalOrderCacheUpdate
    ****************************/
    gec.Controller.prototype.forceLocalOrderCacheUpdate = function (params) {

        if (gecPrivate.userContext == null
            && gecPrivate.sessionToken !== undefined) {

            params.callbackOnException.call(this, { returnCode: 590 });

        } else {

            var request = new gec.IAPIRequest(params);
            request.sessionToken = gecPrivate.sessionToken;
            request.sequenceNumber = gecPrivate._maxSequenceNo;
            this.sendRequest("/ListOrdersChangedSince.ashx", request, _forceLocalOrderCacheUpdateResponse);
        }
    };
    var _forceLocalOrderCacheUpdateResponse = function (request, response) {
        var structuralChange = false;
        if (gecPrivate.userContext != null) {
            var unknownMarketIds = {};
            var needMarketInformation = false; //used to call listExchangeMarketInformation
            var context = this;
            if ((response.returnCode == 0) && (response.orders != null)) {
                for (var orderi = 0; orderi < response.orders.length; orderi++) {

                    if (gecPrivate._orderCache == null) gecPrivate._orderCache = {};
                    if ((response.orders[orderi].status == 3) && (response.orders[orderi].matchedStake.amount == 0))//cancelled
                    {
                        structuralChange = true;

                        if ((gecPrivate._orderCache[response.orders[orderi].orderId] != null) && (gecPrivate._orderCache[response.orders[orderi].orderId].fireOnChange != null))
                            gecPrivate._orderCache[response.orders[orderi].orderId].fireOnChange.call(null, { orderId: response.orders[orderi].orderId, order: null });


                        gecPrivate._orderCache[response.orders[orderi].orderId] = null;
                        delete gecPrivate._orderCache[response.orders[orderi].orderId];
                        _deletedOrderIds[response.orders[orderi].orderId] = true;
                    }
                    else
                        if ((response.orders[orderi].status == 4) || (response.orders[orderi].status == 5))//cancelled or voided
                        {
                            structuralChange = true;

                            if ((gecPrivate._orderCache[response.orders[orderi].orderId] != null) && gecPrivate._orderCache[response.orders[orderi].orderId].fireOnChange != null)
                                gecPrivate._orderCache[response.orders[orderi].orderId].fireOnChange.call(null, { orderId: response.orders[orderi].orderId, order: null });

                            delete gecPrivate._orderCache[response.orders[orderi].orderId];
                            _deletedOrderIds[response.orders[orderi].orderId] = true;
                        }
                        else {

                            if ((gecPrivate._orderCache[response.orders[orderi].orderId] == null) || (gecPrivate._orderCache[response.orders[orderi].orderId]._new)) {


                                structuralChange = true;

                                if (gecPrivate._selections[response.orders[orderi].selectionId] == null) {
                                    gecPrivate._selections[response.orders[orderi].selectionId] = {};
                                    gecPrivate._selections[response.orders[orderi].selectionId].selectionName = "...";

                                    unknownMarketIds[response.orders[orderi].marketId] = response.orders[orderi].marketId;
                                    needMarketInformation = true;
                                }

                                var thisOrderForced = response.orders[orderi];

                                (function (thisOrderForced) {

                                    if (gecPrivate._markets[response.orders[orderi].marketId] == null) {
                                        gecPrivate._markets[response.orders[orderi].marketId] = {};
                                        gecPrivate._markets[response.orders[orderi].marketId].marketName = response.orders[orderi].marketName || "...";
                                        gecPrivate._markets[response.orders[orderi].marketId].eventClassifier = {};
                                        gecPrivate._markets[response.orders[orderi].marketId].eventClassifier.eventClassifierFullName = response.orders[orderi].eventClassifierFullName || "...";
                                        gecPrivate._markets[response.orders[orderi].marketId].eventClassifier.eventClassifierName = response.orders[orderi].eventClassifierFullName || "...";
                                        gecPrivate._markets[response.orders[orderi].marketId].getEventClassifier = function () {
                                            return gecPrivate._markets[thisOrderForced.marketId].eventClassifier;
                                        }

                                        unknownMarketIds[response.orders[orderi].marketId] = response.orders[orderi].marketId;
                                        needMarketInformation = true;
                                    }

                                    response.orders[orderi].selectionName = gecPrivate._selections[response.orders[orderi].selectionId].selectionName;
                                    response.orders[orderi].marketName = gecPrivate._markets[response.orders[orderi].marketId].marketName;
                                    //response.orders[orderi].eventClassifierFullName = gecPrivate._markets[response.orders[orderi].marketId].eventClassifier.eventClassifierFullName;
                                    if (gecPrivate._orderCache[response.orders[orderi].orderId] != null) {
                                        response.orders[orderi].eventClassifierId = gecPrivate._orderCache[response.orders[orderi].orderId].eventClassifierId();
                                    }
                                    gecPrivate._orderCache[response.orders[orderi].orderId] = new gec.Order(response.orders[orderi]);
                                    delete gecPrivate._orderCache[response.orders[orderi].orderId]._new;

                                    gecPrivate._orderCache[thisOrderForced.orderId].marketTypeId = function () { return thisOrderForced.marketType; };

                                    gecPrivate._orderCache[thisOrderForced.orderId].punterReferenceNumber = thisOrderForced.pnterReferenceNumber;
                                    gecPrivate._orderCache[thisOrderForced.orderId].placePayout = function () { return thisOrderForced.placePayout; };


                                    gecPrivate._orderCache[thisOrderForced.orderId].selectionName = function () {
                                        if (gecPrivate._selections[thisOrderForced.selectionId] != null)
                                            return gecPrivate._selections[thisOrderForced.selectionId].selectionName;
                                        else return thisOrderForced.selectionName || "...";
                                    };
                                    gecPrivate._orderCache[thisOrderForced.orderId].marketName = function () {
                                        if (gecPrivate._markets[thisOrderForced.marketId] != null)
                                            return gecPrivate._markets[thisOrderForced.marketId].marketName;
                                        else return thisOrderForced.marketName || "...";
                                    };
                                    gecPrivate._orderCache[thisOrderForced.orderId].eventClassifierFullName = function () {
                                        if ((gecPrivate._markets[thisOrderForced.marketId] != null) && (gecPrivate._markets[thisOrderForced.marketId].getEventClassifier() !== undefined))
                                            return gecPrivate._markets[thisOrderForced.marketId].getEventClassifier().eventClassifierName;
                                        else return thisOrderForced.eventClassifierFullName || "..."
                                    };
                                    gecPrivate._orderCache[thisOrderForced.orderId].eventClassifierId = function () {
                                        if ((gecPrivate._markets[thisOrderForced.marketId] != null) && (gecPrivate._markets[thisOrderForced.marketId].getEventClassifier()) !== undefined)
                                            return gecPrivate._markets[thisOrderForced.marketId].getEventClassifier().eventClassifierId;
                                        else return thisOrderForced.eventClassifierId || "...";
                                    }
                                })(thisOrderForced);
                            }

                            gecPrivate._orderCache[response.orders[orderi].orderId].orderId = response.orders[orderi].orderId;
                            gecPrivate._orderCache[response.orders[orderi].orderId].orderStatusId = response.orders[orderi].status;
                            gecPrivate._orderCache[response.orders[orderi].orderId].issuedAt = response.orders[orderi].issuedAt;
                            gecPrivate._orderCache[response.orders[orderi].orderId].expiresAt = response.orders[orderi].expiresAt;
                            gecPrivate._orderCache[response.orders[orderi].orderId].requestedStake = response.orders[orderi].matchedStake.amount + response.orders[orderi].unmatchedStake.amount;
                            gecPrivate._orderCache[response.orders[orderi].orderId].requestedPrice = response.orders[orderi].requestedPrice;
                            gecPrivate._orderCache[response.orders[orderi].orderId].isFreeBet = response.orders[orderi].isFreeBet;

                            if (response.orders[orderi].matchedStake.amount >= gecPrivate._orderCache[response.orders[orderi].orderId].matchedStake) {
                                gecPrivate._orderCache[response.orders[orderi].orderId].matchedStake = response.orders[orderi].matchedStake.amount;
                                gecPrivate._orderCache[response.orders[orderi].orderId].unmatchedStake = response.orders[orderi].unmatchedStake.amount;
                                gecPrivate._orderCache[response.orders[orderi].orderId].averageMatchedPrice = response.orders[orderi].matchedPrice;
                            }
                            gecPrivate._orderCache[response.orders[orderi].orderId].expectedSelectionResetCount = response.orders[orderi].expectedSelectionResetCount;
                            gecPrivate._orderCache[response.orders[orderi].orderId].expectedWithdrawalSequenceNumber = response.orders[orderi].expectedWithdrawalSequenceNumber;


                            gecPrivate._orderCache[response.orders[orderi].orderId].polarityId = response.orders[orderi].polarity ? 1 : 2;
                            gecPrivate._orderCache[response.orders[orderi].orderId].cancelOnInRunning = response.orders[orderi].cancelOnInRunning;
                            gecPrivate._orderCache[response.orders[orderi].orderId].cancelIfSelectionReset = response.orders[orderi].cancelIfSelectionReset;
                            gecPrivate._orderCache[response.orders[orderi].orderId].sequenceNumber = response.orders[orderi].sequenceNumber;


                            if (response.orders[orderi].totalForSideMakeStake != null)
                                gecPrivate._orderCache[response.orders[orderi].orderId].totalForSideMakeStake = response.orders[orderi].totalForSideMakeStake.amount;
                            if (response.orders[orderi].totalForSideTakeStake != null)
                                gecPrivate._orderCache[response.orders[orderi].orderId].totalForSideTakeStake = response.orders[orderi].totalForSideTakeStake.amount;
                            gecPrivate._orderCache[response.orders[orderi].orderId].requestedPrice = response.orders[orderi].requestedPrice;
                            gecPrivate._orderCache[response.orders[orderi].orderId].requestedAveragePrice = response.orders[orderi].requestedAveragePrice;
                            gecPrivate._orderCache[response.orders[orderi].orderId].matchedPrice = response.orders[orderi].matchedPrice;

                            if (response.orders[orderi].provisionalMatchedStake != null)
                                gecPrivate._orderCache[response.orders[orderi].orderId].provisionalMatchedStake = response.orders[orderi].provisionalMatchedStake.amount;
                            if (response.orders[orderi].matchedAgainstStake != null)
                                gecPrivate._orderCache[response.orders[orderi].orderId].matchedAgainstStake = response.orders[orderi].matchedAgainstStake.amount;
                            if (response.orders[orderi].provisionalMatchedAgainstStake != null)
                                gecPrivate._orderCache[response.orders[orderi].orderId].provisionalMatchedAgainstStake = response.orders[orderi].provisionalMatchedAgainstStake.amount;

                            gecPrivate._orderCache[response.orders[orderi].orderId].expectedSelectionResetCount = response.orders[orderi].expectedSelectionResetCount;
                            gecPrivate._orderCache[response.orders[orderi].orderId].expectedWithdrawalSequenceNumber = response.orders[orderi].expectedWithdrawalSequenceNumber;
                            gecPrivate._orderCache[response.orders[orderi].orderId].orderStatusId = response.orders[orderi].status;
                            gecPrivate._orderCache[response.orders[orderi].orderId].expiresAt = response.orders[orderi].expiresAt;
                            gecPrivate._orderCache[response.orders[orderi].orderId].cancelOnInRunning = response.orders[orderi].cancelOnInRunning;
                            gecPrivate._orderCache[response.orders[orderi].orderId].cancelIfSelectionReset = response.orders[orderi].cancelIfSelectionReset;
                            gecPrivate._orderCache[response.orders[orderi].orderId].isCurrentlyInRunning = response.orders[orderi].isCurrentlyInRunning;
                            gecPrivate._orderCache[response.orders[orderi].orderId].willBeInRunning = response.orders[orderi].willBeInRunning;
                            gecPrivate._orderCache[response.orders[orderi].orderId].isMarketConfused = response.orders[orderi].isMarketConfused;
                            gecPrivate._orderCache[response.orders[orderi].orderId].commissionBasis = response.orders[orderi].commissionBasis;
                            gecPrivate._orderCache[response.orders[orderi].orderId].makeCommissionRate = response.orders[orderi].makeCommissionRate;
                            gecPrivate._orderCache[response.orders[orderi].orderId].takeCommissionRate = response.orders[orderi].takeCommissionRate;
                            if (response.orders[orderi].orderFillType)
                                gecPrivate._orderCache[response.orders[orderi].orderId].orderFillType = response.orders[orderi].orderFillType;

                            if (response.orders[orderi].orderPAndL != null)
                                gecPrivate._orderCache[response.orders[orderi].orderId].orderPAndL = orderPAndL.amount;
                            if (response.orders[orderi].taxAmountDeducted != null)
                                gecPrivate._orderCache[response.orders[orderi].orderId].taxAmountDeducted = taxAmountDeducted.amount;
                            if (response.orders[orderi].orderCommission != null)
                                gecPrivate._orderCache[response.orders[orderi].orderId].orderCommission = orderCommission.amount;

                            if (gecPrivate._orderCache[response.orders[orderi].orderId].fireOnChange != null)
                                gecPrivate._orderCache[response.orders[orderi].orderId].fireOnChange.call(null, { orderId: response.orders[orderi].orderId, order: gecPrivate._orderCache[response.orders[orderi].orderId] });
                        }
                }
                gecPrivate._maxSequenceNo = response.orders[response.orders.length - 1].sequenceNumber;
                //this._orderChangedEvent.call(this, response.orders);
            }
            if (structuralChange)
                _processFireOnChange();
            var thisObj = this;

            if (needMarketInformation) {
                var marketIds = [];
                for (marketI in unknownMarketIds) {
                    marketIds[marketIds.length] = unknownMarketIds[marketI];
                }
                gecPrivate._thisController.getExchangePrices({
                    callbackOnSuccess: function (markets) {

                        for (var marketI = 0; marketI < markets.length; marketI++) {
                            if (gecPrivate._eventClassifiers[markets[marketI].eventClassifierId] == null) {
                                gecPrivate._eventClassifiers[markets[marketI].eventClassifierId] = {};
                                if (markets[marketI].eventClassifierFullName == null) markets[marketI].eventClassifierFullName = "unknown";
                            }
                            gecPrivate._eventClassifiers[markets[marketI].eventClassifierId].eventClassifierId = markets[marketI].eventClassifierId;
                            gecPrivate._eventClassifiers[markets[marketI].eventClassifierId].eventClassifierFullName = markets[marketI].eventClassifierFullName;
                            gecPrivate._eventClassifiers[markets[marketI].eventClassifierId].eventClassifierName = gecPrivate._base.getEventName(markets[marketI].eventClassifierFullName);

                            if (gecPrivate._markets[markets[marketI].marketId] == null) {
                                gecPrivate._markets[markets[marketI].marketId] = {};
                            }
                            gecPrivate._markets[markets[marketI].marketId].marketId = markets[marketI].marketId;
                            gecPrivate._markets[markets[marketI].marketId].marketName = markets[marketI].marketName;
                            gecPrivate._markets[markets[marketI].marketId].eventClassifier = gecPrivate._eventClassifiers[markets[marketI].eventClassifierId];

                            if (gecPrivate._markets[markets[marketI].marketId].selections == null) {
                                gecPrivate._markets[markets[marketI].marketId].selections = markets[marketI].selections;
                            }

                            for (var selectionI = 0; selectionI < markets[marketI].selections.length; selectionI++) {
                                if (gecPrivate._selections[markets[marketI].selections[selectionI].selectionId] == null) {
                                    gecPrivate._selections[markets[marketI].selections[selectionI].selectionId] = {};
                                }
                                gecPrivate._selections[markets[marketI].selections[selectionI].selectionId].selectionName = markets[marketI].selections[selectionI].selectionName;
                            }
                        }


                    },
                    callbackOnException: function () { },
                    marketIds: marketIds,
                    markets: null,
                    eventClassifierId: null,
                    marketTypeId: null,
                    playMarkets: false,
                    eventClassifier: null,
                    wantIcons: false,
                    justRefreshPrices: false,
                    thresholdAmount: 1,
                    numberForPricesRequired: 0,
                    numberAgainstPricesRequired: 0
                });

                //                    gecPrivate._thisController.listExchangeMarketInformation({
                //                        callbackOnSuccess: null,
                //                        callbackOnException: null,
                //                        marketIds: marketIds//,
                //                        //incompleteOrders: incompleteOrders
                //                    });
            }

            if (request.callbackOnSuccess != null) {
                request.callbackOnSuccess.call(this, {});
            }

        }
    };

    /************************************
    marketPAndL
    ************************************/
    gec.Controller.prototype.marketPAndL = function (params) {
        //params.includeSettledSelections: boolean

        if (gecPrivate._orderCache !== null) {
            var marketId = -1;
            if (params.marketId != null) {
                marketId = params.marketId;
            }
            else if (params.market != null) {
                marketId = params.market.marketId;
            }
            else if (params.marketDetail != null) {
                marketId = params.marketDetail.marketId;
            }

            var returnObj = { selections: {} };

            var selectionIndex = {};
            var totalStake = 0;

            var totalAgainstSideGain = 0, commission, stake;
            var upsideIfSettledFor, upsideIfSettledPlace;

            var grossUpsideFor, grossUpsideForCommission, grossUpsideAgainst, grossUpsideAgainstCommission;
            var totalGrossUpsideFor = 0, totalGrossUpsideForCommission = 0;

            var orders = params.orders || gecPrivate._orderCache;
            for (orderItem in orders) {
                var thisOrder = orders[orderItem];

                if (thisOrder.orderStatusId == 4 && !params.includeSettledSelections) {
                    continue;
                }

                if (thisOrder.marketId() === marketId) {
                    if ((thisOrder.matchedStake + thisOrder.matchedAgainstStake) > 0) {

                        var eachWayDivisor = (thisOrder.placePayout() > 0) ? 2 : 1;
                        var thisSelectionId = thisOrder.selectionId();
                        selectionIndex[thisSelectionId] = selectionIndex[thisSelectionId] || {
                            selectionId: thisSelectionId,
                            upsideIfSettledFor: 0,
                            upsideIfSettledAgainst: 0,
                            commission: 0,
                            grossUpsideFor: 0,
                            grossUpsideForCommission: 0,
                            grossUpsideAgainst: 0,
                            grossUpsideAgainstCommission: 0,
                            upsideIfSettledPlace: (params.placePayout > 0) ? 0 : undefined,
                            netSelectionPosition: (params.numberOfWinningSelections == 1) ? 0 : undefined
                        };

                        //ForSideWin

                        var polMultiple = (thisOrder.polarityId == 1) ? 1 : -1;

                        grossUpsideFor = 0;
                        grossUpsideForCommission = 0;
                        grossUpsideAgainst = 0;
                        grossUpsideAgainstCommission = 0;

                        commission = 0;

                        //AgainstSide
                        var againstSideGain = ((thisOrder.polarityId == 1) ? -thisOrder.matchedStake : thisOrder.matchedStake) / eachWayDivisor;

                        //ForSidePlace

                        if (params.placePayout > 0) {
                            upsideIfSettledFor = polMultiple * (((thisOrder.averageMatchedPrice - 1) * params.placePayout * (thisOrder.matchedStake / 2)) + (thisOrder.averageMatchedPrice - 1) * (thisOrder.matchedStake / 2));
                            upsideIfSettledPlace = polMultiple * (((thisOrder.averageMatchedPrice - 1) * params.placePayout * (thisOrder.matchedStake / 2)) - (thisOrder.matchedStake / 2));
                            againstSideGain = ((params.placePayout > 0) ? againstSideGain * 2 : againstSideGain);
                            if (params.displayPandLNetOfCommission && upsideIfSettledFor > 0) {
                                commission = upsideIfSettledFor * ((thisOrder.totalForSideTakeStake > 0 ? thisOrder.takeCommissionRate : thisOrder.makeCommissionRate) / 100);
                            }

                            selectionIndex[thisSelectionId].upsideIfSettledFor += upsideIfSettledFor;
                            selectionIndex[thisSelectionId].upsideIfSettledPlace += upsideIfSettledPlace;
                        } else {
                            var forSideGain = (thisOrder.polarityId == gec.Polarity.For) ? thisOrder.matchedAgainstStake : -thisOrder.matchedAgainstStake;
                            if (params.displayPandLNetOfCommission) {
                                commission = ((thisOrder.totalForSideTakeStake * (thisOrder.averageMatchedPrice - 1)) * (thisOrder.takeCommissionRate / 100)) + ((thisOrder.totalForSideMakeStake * (thisOrder.averageMatchedPrice - 1)) * (thisOrder.makeCommissionRate / 100));
                            }

                            selectionIndex[thisSelectionId].upsideIfSettledFor += forSideGain;
                        }


                        if (thisOrder.polarityId == gec.Polarity.Against) {
                            grossUpsideFor += thisOrder.matchedStake;
                            grossUpsideAgainst = thisOrder.matchedStake;
                            selectionIndex[thisSelectionId].grossUpsideAgainst += grossUpsideAgainst;

                        } else {
                            grossUpsideFor += thisOrder.matchedStake * (thisOrder.averageMatchedPrice - 1);
                        }

                        if (params.displayPandLNetOfCommission) {

                            if (thisOrder.polarityId == gec.Polarity.Against) {
                                grossUpsideForCommission = ((thisOrder.totalForSideTakeStake * (thisOrder.takeCommissionRate / 100)) + (thisOrder.totalForSideMakeStake * (thisOrder.makeCommissionRate / 100)));
                                grossUpsideAgainstCommission = ((thisOrder.totalForSideTakeStake * (thisOrder.takeCommissionRate / 100)) + (thisOrder.totalForSideMakeStake * (thisOrder.makeCommissionRate / 100)));
                                selectionIndex[thisSelectionId].grossUpsideAgainstCommission += grossUpsideAgainstCommission;

                            } else {
                                grossUpsideForCommission = (((thisOrder.totalForSideTakeStake * (thisOrder.averageMatchedPrice - 1)) * (thisOrder.takeCommissionRate / 100)) + (thisOrder.totalForSideMakeStake * (thisOrder.averageMatchedPrice - 1) * (thisOrder.makeCommissionRate / 100)));
                            }

                        }

                        totalGrossUpsideFor += grossUpsideFor;
                        totalGrossUpsideForCommission += grossUpsideForCommission;

                        selectionIndex[thisSelectionId].grossUpsideFor += grossUpsideFor;
                        selectionIndex[thisSelectionId].grossUpsideForCommission += grossUpsideForCommission;
                        selectionIndex[thisSelectionId].upsideIfSettledAgainst += againstSideGain;
                        totalAgainstSideGain += againstSideGain;

                        stake = ((thisOrder.polarityId == 1) ? -thisOrder.matchedStake : thisOrder.matchedStake);

                        totalStake += stake;
                    }
                }
            }
            var netSelectionPosition;
            for (var i in selectionIndex) {
                var selectionFigures = selectionIndex[i];
                if (selectionFigures != null) {
                    if (params.numberOfWinningSelections == 1) {
                        netSelectionPosition = selectionFigures.upsideIfSettledFor - (selectionFigures.upsideIfSettledAgainst - totalAgainstSideGain);

                        if (netSelectionPosition > 0 && params.displayPandLNetOfCommission) {
                            commission = netSelectionPosition * (selectionFigures.grossUpsideForCommission / selectionFigures.grossUpsideFor);
                            netSelectionPosition -= commission;
                        }
                        if (netSelectionPosition === Infinity) {
                            console.error("Infinity");
                        }
                        selectionFigures.netSelectionPosition = netSelectionPosition;// === Infinity ? 0 : netSelectionPosition;
                    } else {
                        if (selectionFigures.upsideIfSettledFor > 0) {
                            selectionFigures.upsideIfSettledFor = selectionFigures.upsideIfSettledFor - (params.displayPandLNetOfCommission ? selectionFigures.upsideIfSettledFor * (selectionFigures.grossUpsideForCommission / selectionFigures.grossUpsideFor) : 0);
                        }
                        if (selectionFigures.upsideIfSettledPlace > 0) {
                            selectionFigures.upsideIfSettledPlace = selectionFigures.upsideIfSettledPlace - (params.displayPandLNetOfCommission ? selectionFigures.upsideIfSettledPlace * (selectionFigures.grossUpsideForCommission / selectionFigures.grossUpsideFor) : 0);
                        }
                        if (selectionFigures.upsideIfSettledAgainst > 0) {
                            selectionFigures.upsideIfSettledAgainst = selectionFigures.upsideIfSettledAgainst - (params.displayPandLNetOfCommission ? selectionFigures.upsideIfSettledAgainst * (selectionFigures.grossUpsideAgainstCommission / selectionFigures.grossUpsideAgainst) : 0);
                        }
                    }

                    returnObj.selections[i] = selectionFigures;
                }
            }

            if (params.numberOfWinningSelections == 1) {
                if (params.displayPandLNetOfCommission && totalStake > 0) {
                    totalStake -= totalStake * (totalGrossUpsideForCommission / totalGrossUpsideFor);
                }

                returnObj.defaultNetSelectionPosition = totalStake;
            }

            return returnObj;
        }
        else {
            throw { "number": 592, "message": "OrderCacheNotPresent" };
        }

    };

    /************************************
    listOrdersByTimePlaced
    ************************************/
    gec.Controller.prototype.listOrdersByTimePlaced = function (params, isInternal) {
        if (gecPrivate._orderCache != null) {
            params.sortDescending = (params.sortDescending == null) ? true : params.sortDescending;
            var orders = [];
            var orderI = 0;
            var markets = (params.markets != null) ? params.markets : params.marketDetail;
            var eventClassifiers = params.eventClassifiers;
            var marketIds = [];
            var eventClassifierIds = [];
            if (markets != null) {
                for (var marketCount = 0; marketCount < markets.length; marketCount++) {
                    marketIds[marketIds.length] = markets[marketCount].marketId;
                }
            }
            else if (params.marketIds != null) {
                marketIds = params.marketIds;
            }

            if (marketIds != null) {
                for (orderId in gecPrivate._orderCache) {
                    for (var marketCount = 0; marketCount < marketIds.length; marketCount++) {
                        if (gecPrivate._orderCache[orderId].marketId() == marketIds[marketCount]) {
                            orders[orderI++] = gecPrivate._orderCache[orderId];
                        }
                    }
                }
            }

            if (eventClassifiers != null) {
                for (var eventClassifierCount = 0; eventClassifierCount < eventClassifiers.length; eventClassifierCount++) {
                    eventClassifierIds[eventClassifierIds.length] = eventClassifiers[eventClassifierCount].eventClassifierId;
                }
            }
            else if (params.eventClassifierIds != null) {
                eventClassifierIds = params.eventClassifierIds;
            }

            if (eventClassifierIds != null) {
                for (orderId in gecPrivate._orderCache) {
                    for (var eventClassifierCount = 0; eventClassifierCount < eventClassifierIds.length; eventClassifierCount++) {
                        if (gecPrivate._orderCache[orderId].eventClassifierId == eventClassifierIds[eventClassifierCount]) {
                            orders[orderI++] = gecPrivate._orderCache[orderId];
                        }
                    }
                }
            }
            if ((markets == null) && (params.eventClassifierIds == null) && (params.eventClassifiers == null) && (params.marketIds == null)) {
                for (orderId in gecPrivate._orderCache) {
                    orders[orderI++] = gecPrivate._orderCache[orderId];
                }
            }

            orders.sort(gec.SortOnIssuedAt);

            if (params.sortDescending)
                orders.reverse();

            if (isInternal) {
                if (params.fireOnChange != null) {
                    var fireOnChangeData = _getFireOnChange(orders, _overlays[params.overlayId], params.sortDescending);
                    params.fireOnChange.call(this, fireOnChangeData);
                }
            }

            _overlays[params.overlayId] = {};
            _overlays[params.overlayId].params = params;
            _overlays[params.overlayId].type = "TimePlaced";
            _overlays[params.overlayId].orders = orders;
            return _overlays[params.overlayId].orders;
        }
        else {
            throw { "number": 592, "message": "OrderCacheNotPresent" };
        }
    };

    /************************************
    listOrdersByTimeChanged
    ************************************/
    gec.Controller.prototype.listOrdersByTimeChanged = function (params, isInternal) {
        if (gecPrivate._orderCache != null) {
            params.sortDescending = (params.sortDescending == null) ? true : params.sortDescending;
            var orders = [];
            var orderI = 0;
            var markets = (params.markets != null) ? params.markets : params.marketDetail;
            var marketIds = [];
            if (markets != null) {
                for (marketCount in markets) {
                    marketIds[marketIds.length] = markets[marketCount].marketId;
                }
            }
            else {
                marketIds = params.marketIds;
            }
            if (marketIds != null) {
                for (orderId in gecPrivate._orderCache) {
                    for (var marketCount = 0; marketCount < marketIds.length; marketCount++) {
                        if (gecPrivate._orderCache[orderId].marketId() == marketIds[marketCount]) {
                            orders[orderI++] = gecPrivate._orderCache[orderId];
                        }
                    }
                }
            }
            else {
                for (orderId in gecPrivate._orderCache) {
                    orders[orderI++] = gecPrivate._orderCache[orderId];
                }
            }

            orders.sort(gec.SortOnChangedAt);

            if (params.sortDescending)
                orders.reverse();


            if (isInternal) {
                if (params.fireOnChange != null) {
                    var fireOnChangeData = _getFireOnChange(orders, _overlays[params.overlayId].orders, params.sortDescending);
                    params.fireOnChange.call(this, fireOnChangeData);
                }
            }

            _overlays[params.overlayId] = {};
            _overlays[params.overlayId].params = params;
            _overlays[params.overlayId].type = "TimeChanged";
            _overlays[params.overlayId].orders = orders;
            return _overlays[params.overlayId].orders;
        }
        else {
            throw { "number": 592, "message": "OrderCacheNotPresent" };
        }
    };
    _processFireOnChange = function () {
        console.log(_processFireOnChange);

        for (overlayCount in _overlays) {
            if (_overlays[overlayCount].params.fireOnChange) {

                if (_overlays[overlayCount].type == "TimeChanged")
                    gecPrivate._thisController.listOrdersByTimeChanged(_overlays[overlayCount].params, true);
                else
                    gecPrivate._thisController.listOrdersByTimePlaced(_overlays[overlayCount].params, true);
            }
        }
    };

    _getFireOnChange = function (newArray, oldArray, sortDecending) {
        var fireOnChangeArray = [];
        if (sortDecending) {
            var i = 0;
            do {
                if (newArray[newArray.length - 1 - i] == null) {
                    fireOnChangeArray[fireOnChangeArray.length] = { offset: Math.max(0, oldArray.length - 1 - i), order: null, orderId: oldArray[oldArray.length - 1 - i].orderId };
                    oldArray.splice(Math.max(0, oldArray.length - 1 - i), 1);
                } else
                    if (oldArray[oldArray.length - 1 - i] == null) {
                        fireOnChangeArray[fireOnChangeArray.length] = { offset: Math.max(0, oldArray.length - 1 - i), order: newArray[newArray.length - 1 - i] };
                        oldArray.splice(Math.max(0, oldArray.length - 1 - i), 0, newArray[newArray.length - 1 - i]);
                        i++;
                    }
                    else {
                        if (oldArray[oldArray.length - 1 - i].orderId != newArray[newArray.length - 1 - i].orderId) {
                            fireOnChangeArray[fireOnChangeArray.length] = { offset: Math.max(0, oldArray.length - 1 - i), order: null, orderId: oldArray[oldArray.length - 1 - i].orderId };
                            oldArray.splice(Math.max(0, oldArray.length - 1 - i), 1);
                        }
                        else {
                            i++;
                        }
                    }

            } while (i < Math.max(oldArray.length, newArray.length))
        }
        else {
            var i = 0;
            do {
                if (newArray[i] == null) {
                    oldArray.splice(i, 1);
                    fireOnChangeArray[fireOnChangeArray.length] = { offset: i, order: null };
                }
                else {
                    if (oldArray[i].orderId != newArray[i].orderId) {
                        oldArray.splice(i, 1);
                        fireOnChangeArray[fireOnChangeArray.length] = { offset: i, order: null };
                    }
                    else {
                        i++;
                    }
                }

            } while (i < Math.max(oldArray.length, newArray.length))

        }
        return fireOnChangeArray;
    };


    /****************************
    placeOrders
    ****************************/

    gec.Controller.prototype.placeOrders = function (params) {
        if (gecPrivate.userContext == null) {
            params.callbackOnException.call(this, { returnCode: 590 });
        }
        else {
            var request = new gec.IAPIRequest(params);
            request.sessionToken = gecPrivate.sessionToken;

            request.returnMatchInformation = params.returnMatchInformation;
            request.channelInformation = /*"-GEC" + _version.implementationVersion + "|" + */params.channelInformation;
            request.wantAllOrNothingBehaviour = params.wantAllOrNothingBehaviour;
            request.useFreeBet = params.useFreeBet;
            request.orders = [];
            for (var i = 0; i < params.ordersRequested.length; i++) {
                var thisSelection = params.ordersRequested[i].selection || params.ordersRequested[i].subscribedSelection;
                request.orders[i] = {};

                request.orders[i].selectionId = thisSelection.selectionId;
                request.orders[i].expiresAt = params.ordersRequested[i].expiresAt;
                request.orders[i].orderFillType = params.ordersRequested[i].orderFillType;

                request.orders[i].fillOrKillThreshold = { "amount": params.ordersRequested[i].fillOrKillThreshold, "currency": gecPrivate.userContext.currency };
                request.orders[i].fillOrKillThresholdSpecified = (params.ordersRequested[i].fillOrKillThreshold != null) ? true : false;

                request.orders[i].requestedForSideStake = { "amount": params.ordersRequested[i].requestedForSideStake, "currency": gecPrivate.userContext.currency };
                request.orders[i].requestedForSidePrice = params.ordersRequested[i].requestedForSidePrice;
                request.orders[i].requestedAverageForSidePrice = params.ordersRequested[i].requestedAverageForSidePrice;
                request.orders[i].expectedSelectionResetCount = params.ordersRequested[i].expectedSelectionResetCount;
                request.orders[i].expectedWithdrawalSequenceNumber = params.ordersRequested[i].expectedWithdrawalSequenceNumber;
                request.orders[i].polarity = params.ordersRequested[i].polarityId;
                request.orders[i].withdrawRepriceOption = params.ordersRequested[i].withdrawRepriceOptionId;
                request.orders[i].cancelOnInRunning = params.ordersRequested[i].cancelOnInRunning;
                request.orders[i].cancelIfSelectionReset = params.ordersRequested[i].cancelIfSelectionReset;
            }

            this.sendRequest("/PlaceOrders.ashx", request, function (request, response) { _placeOrdersResponse.call(this, request, response, params.ordersRequested) });
        }
    };
    var _placeOrdersResponse = function (request, response, ordersToPlace) {

        if (response.returnCode != 0) {
            request.callbackOnException.call(this, { returnCode: response.returnCode });
        } else {
            var output = {};
            if (response.totalStakeDebited != null)
                output.totalStakeDebited = response.totalStakeDebited.amount;

            output.responses = [];

            if (gecPrivate._orderCache == null)
                gecPrivate._orderCache = {};
            for (var i = 0; i < response.orders.length; i++) {
                var thisOrder = response.orders[i];
                output.responses[i] = {};

                if (_deletedOrderIds[thisOrder.orderId]) continue; //if its already been deleted then skip to next one.

                if (thisOrder.returnCode != 0) {
                    output.responses[i].returnCode = thisOrder.returnCode;

                } else {

                    if (ordersToPlace[i].subscribedSelection == null) {//Selection object as opposed to subscribed selection object
                        response.orders[i].selectionId = ordersToPlace[i].selection.selectionId;
                        response.orders[i].selectionName = ordersToPlace[i].selection.selectionName;
                        response.orders[i].eventClassifierFullName = ordersToPlace[i].selection.market.eventClassifierFullName;
                        response.orders[i].eventClassifierId = ordersToPlace[i].selection.market.eventClassifierId;
                        response.orders[i].marketName = ordersToPlace[i].selection.market.marketName;
                        response.orders[i].marketId = ordersToPlace[i].selection.market.marketId;
                    } else {
                        response.orders[i].selectionId = ordersToPlace[i].subscribedSelection.selectionId;
                        response.orders[i].selectionName = ordersToPlace[i].subscribedSelection.name;
                        if (ordersToPlace[i].subscribedSelection.market) {
                            response.orders[i].marketId = ordersToPlace[i].subscribedSelection.market.marketId;
                        } else {
                            response.orders[i].marketId = ordersToPlace[i].subscribedSelection.marketId;
                        }

                        response.orders[i].marketName = ordersToPlace[i].marketName;
                        response.orders[i].eventClassifierFullName = ordersToPlace[i].eventClassifierFullName;
                        response.orders[i].eventClassifierId = ordersToPlace[i].eventClassifierId;
                    }

                    response.orders[i].requestedStake = ordersToPlace[i].requestedForSideStake;
                    response.orders[i].requestedPrice = ordersToPlace[i].requestedForSidePrice;

                    //order may already exist from update orders calls
                    if (gecPrivate._orderCache[response.orders[i].orderId] == null) {
                        gecPrivate._orderCache[response.orders[i].orderId] = new gec.Order(response.orders[i]);
                        if (response.orders[i].matchedAgainstSideStake != null) {
                            gecPrivate._orderCache[response.orders[i].orderId].matchedAgainstStake = response.orders[i].matchedAgainstSideStake.amount;
                        }
                        gecPrivate._orderCache[response.orders[i].orderId].isFreeBet = request.useFreeBet;
                        gecPrivate._orderCache[response.orders[i].orderId].placePayout = function () { return 0; };
                        gecPrivate._orderCache[response.orders[i].orderId]._new = true; //remove when fireonchange on listorderchanged since

                    }

                    var orderI = i;
                    (function (orderI) {
                        gecPrivate._orderCache[response.orders[orderI].orderId].selectionName = function () { return response.orders[orderI].selectionName };
                        gecPrivate._orderCache[response.orders[orderI].orderId].marketName = function () { return response.orders[orderI].marketName };

                        gecPrivate._orderCache[response.orders[orderI].orderId].eventClassifierFullName = function () {
                            return response.orders[orderI].eventClassifierFullName;
                        };

                    })(orderI);


                    if (response.orders[i].matchedStake != null) {
                        if (response.orders[i].matchedStake.amount > gecPrivate._orderCache[response.orders[i].orderId].matchedStake) {
                            gecPrivate._orderCache[response.orders[i].orderId].matchedStake = response.orders[i].matchedStake.amount;
                            gecPrivate._orderCache[response.orders[i].orderId].unmatchedStake = response.orders[i].requestedStake - gecPrivate._orderCache[response.orders[i].orderId].matchedStake;
                            gecPrivate._orderCache[response.orders[i].orderId].averageMatchedPrice = response.orders[i].matchedPrice;

                        }
                    }
                    gecPrivate._orderCache[response.orders[i].orderId].orderId = response.orders[i].orderId;
                    gecPrivate._orderCache[response.orders[i].orderId].issuedAt = new Date().formatDate("yyyy-MM-ddThh:mm:ss.SSSZ");
                    gecPrivate._orderCache[response.orders[i].orderId].expiresAt = ordersToPlace[i].expiresAt;
                    gecPrivate._orderCache[response.orders[i].orderId].requestedStake = response.orders[i].requestedStake;
                    gecPrivate._orderCache[response.orders[i].orderId].requestedPrice = ordersToPlace[i].requestedForSidePrice;
                    gecPrivate._orderCache[response.orders[i].orderId].unmatchedStake = response.orders[i].requestedStake - gecPrivate._orderCache[response.orders[i].orderId].matchedStake;


                    if ((request.orders[i].orderFillType == 2) && (gecPrivate._orderCache[response.orders[i].orderId].unmatchedStake > 0)) {
                        gecPrivate._orderCache[response.orders[i].orderId].orderStatusId = 3;
                    } else {
                        gecPrivate._orderCache[response.orders[i].orderId].orderStatusId = ((response.orders[i].requestedStake - gecPrivate._orderCache[response.orders[i].orderId].matchedStake) > 0) ? 1 : 2;
                    }

                    gecPrivate._orderCache[response.orders[i].orderId].expectedSelectionResetCount = ordersToPlace[i].expectedSelectionResetCount;
                    gecPrivate._orderCache[response.orders[i].orderId].expectedWithdrawalSequenceNumber = ordersToPlace[i].expectedWithdrawalSequenceNumber;

                    gecPrivate._orderCache[response.orders[i].orderId].polarityId = ordersToPlace[i].polarityId;
                    gecPrivate._orderCache[response.orders[i].orderId].cancelOnInRunning = ordersToPlace[i].cancelOnInRunning;
                    gecPrivate._orderCache[response.orders[i].orderId].cancelIfSelectionReset = request.orders[i].cancelIfSelectionReset;
                    gecPrivate._orderCache[response.orders[i].orderId].orderFillType = request.orders[i].orderFillType;

                    output.responses[i].orderId = response.orders[i].orderId;
                    output.responses[i].order = (gecPrivate._orderCache != null) ? gecPrivate._orderCache[response.orders[i].orderId] : null;

                }
            }

            request.callbackOnSuccess.call(this, output);
        }

    };
    /****************************
    changeOrders
    ****************************/
    gec.Controller.prototype.changeOrders = function (params) {
        if (gecPrivate.userContext == null) {
            params.callbackOnException.call(this, { returnCode: 590 });
        }
        else {
            var request = new gec.IAPIRequest(params);
            request.sessionToken = gecPrivate.sessionToken;
            request.returnMatchInformation = params.returnMatchInformation;
            request.orders = [];
            for (var orderCount = 0; orderCount < params.orders.length; orderCount++) {
                var order = {};

                order.orderId = params.orders[orderCount].orderId * 1;
                order.punterReferenceNumberSpecified = (params.orders[orderCount].punterReferenceNumber != null) ? true : false;;
                order.expiresAt = params.orders[orderCount].expiresAt;
                order.expiresAtSpecified = (params.orders[orderCount].expiresAt != null) ? true : false;
                order.deltaAmount = { amount: params.orders[orderCount].deltaAmount, currency: gecPrivate.userContext.currency };
                order.requestedForSidePrice = params.orders[orderCount].requestedForSidePrice;
                order.expectedSelectionResetCount = params.orders[orderCount].expectedSelectionResetCount;
                order.expectedWithdrawalSequenceNumber = params.orders[orderCount].expectedWithdrawalSequenceNumber;
                order.withdrawRepriceOption = params.orders[orderCount].withdrawRepriceOption;
                order.withdrawRepriceOptionSpecified = (params.orders[orderCount].withdrawRepriceOption != null) ? true : false;
                order.cancelOnInRunning = params.orders[orderCount].cancelOnInRunning;
                order.cancelOnInRunningSpecified = params.orders[orderCount].cancelOnInRunningSpecified;
                order.cancelIfSelectionReset = params.orders[orderCount].cancelIfSelectionReset;
                order.cancelIfSelectionResetSpecified = (params.orders[orderCount].cancelIfSelectionReset != null) ? true : false;
                if (params.orders[orderCount].setToBeSPIfUnmatched != null) {
                    order.setToBeSPIfUnmatched = params.orders[orderCount].setToBeSPIfUnmatched;
                }
                request.orders[request.orders.length] = order;
            }
            //this.ordersToChange = params.orders;
            this.sendRequest("/ChangeOrders.ashx", request, _changeOrdersResponse);
        }
    };
    var _changeOrdersResponse = function (request, response) {
        if (response.returnCode == 0) {

            var output = [];
            for (var i = 0; i < response.orders.length; i++) {
                output[i] = {};
                output[i].returnCode = response.orders[i].returnCode;
                if (response.orders[i].returnCode == 0) {
                    output[i].averageMatchedPrice = response.orders[i].matchedPrice;

                    if (response.orders[i].matchedStake)
                        output[i].matchedStake = response.orders[i].matchedStake.amount;

                    if (response.orders[i].provisionalMatchedStake)
                        output[i].provisionalMatchedStake = response.orders[i].provisionalMatchedStake.amount;

                    if (response.orders[i].matchedAgainstSideStake)
                        output[i].matchedAgainstSideStake = response.orders[i].matchedAgainstSideStake.amount;

                    if (response.orders[i].provisionalMatchedAgainstSideStake)
                        output[i].provisionalMatchedAgainstSideStake = response.orders[i].provisionalMatchedAgainstSideStake.amount;

                    if (gecPrivate._orderCache != null) {
                        if (gecPrivate._orderCache[request.orders[i].orderId] != null)
                            output[i].order = gecPrivate._orderCache[request.orders[i].orderId]
                    }
                }
            }
            request.callbackOnSuccess.call(this, output);
        } else {
            gecPrivate.checkExpiredSession(response.returnCode);
            request.callbackOnException.call(this, new gec.AsyncException(response));
        }
    };
    /****************************
    cancelOrders
    ****************************/
    gec.Controller.prototype.cancelOrders = function (params) {
        if (gecPrivate.userContext == null) {
            params.callbackOnException.call(this, new gec.AsyncException({ returnCode: 590 }));
        }
        else {
            var request = new gec.IAPIRequest(params);
            request.sessionToken = gecPrivate.sessionToken;

            if (params.marketIds != null) {
                if (params.marketIds.length > 0) {
                    request.orderIds = null;
                    request.marketIds = params.marketIds;
                }
            }
            else {
                if (params.orderIds.length > 0) {
                    request.marketIds = null;
                    request.orderIds = params.orderIds;
                }
            }
            if (!((request.orderIds == null) && (request.marketIds == null)))
                this.sendRequest("/CancelOrders.ashx", request, _cancelOrdersResponse);

        }
    };
    var _cancelOrdersResponse = function (request, response) {

        if (response.returnCode != 0) {
            gecPrivate.checkExpiredSession(response.returnCode);
            request.callbackOnException.call(this, new gec.AsyncException(response));
        } else {
            var returnObj = [];
            if (response.orders != null) {

                for (var i = 0; i < response.orders.length; i++) {
                    returnObj[i] = {};
                    returnObj[i].orderId = response.orders[i].orderId;
                    returnObj[i].cancelledForSideStake = response.orders[i].cancelledForSideStake.amount;
                    if (gecPrivate._orderCache[response.orders[i].orderId] != null) {
                        if (response.orders[i].cancelledForSideStake.amount < gecPrivate._orderCache[response.orders[i].orderId].requestedStake) {
                            gecPrivate._orderCache[response.orders[i].orderId].orderStatusId = 3;
                        }
                        else {
                            gecPrivate._orderCache[response.orders[i].orderId].orderStatusId = 3;

                            if (gecPrivate._orderCache[response.orders[i].orderId].fireOnChange != null)
                                gecPrivate._orderCache[response.orders[i].orderId].fireOnChange.call(null, { orderId: response.orders[i].orderId, order: null });

                            gecPrivate._orderCache[response.orders[i].orderId] = null;
                            delete gecPrivate._orderCache[response.orders[i].orderId];
                            _deletedOrderIds[response.orders[i].orderId] = true;

                        }
                    }
                }
            }
            request.callbackOnSuccess.call(this, returnObj);
        }
    };

    /****************************
   suspendOrders
   ****************************/
    gec.Controller.prototype.suspendOrders = function (params) {

        if (gecPrivate.userContext == null) {

            params.callbackOnException.call(this, new gec.AsyncException({ returnCode: 590 }));

        } else {

            var request = new gec.IAPIRequest(params);
            request.sessionToken = gecPrivate.sessionToken;

            if (params.marketIds !== undefined) {
                if (params.marketIds.length > 0) {
                    request.marketIds = params.marketIds;
                }
            } else {
                if (params.orderIds.length > 0) {
                    request.orderIds = params.orderIds;
                }
            }

            if (!((request.orderIds === undefined) && (request.marketIds === undefined))) {
                this.sendRequest("/SuspendOrders.ashx", request, _suspendOrdersResponse);
            }

        }
    };
    var _suspendOrdersResponse = function (request, response) {

        if (response.returnCode != 0) {
            gecPrivate.checkExpiredSession(response.returnCode);
            request.callbackOnException.call(this, new gec.AsyncException(response));
        } else {
            if (response.orders) {
                var orderCache = gecPrivate._orderCache;

                response.orders.forEach(function (thisOrderResponse) {
                    if (thisOrderResponse.suspendedForSideStake && thisOrderResponse.suspendedForSideStake.amount > 0 && orderCache[thisOrderResponse.orderId] !== undefined) {
                        orderCache[thisOrderResponse.orderId].orderStatusId = 6;
                    }

                })
            }
            request.callbackOnSuccess.call(this, response.orders);
        }
    };

    /****************************
    unsuspendOrders
    ****************************/

    gec.Controller.prototype.unsuspendOrders = function (params) {

        if (gecPrivate.userContext == null) {

            params.callbackOnException.call(this, new gec.AsyncException({ returnCode: 590 }));

        } else {

            var request = new gec.IAPIRequest(params);
            request.sessionToken = gecPrivate.sessionToken;

            if (params.orderIds.length > 0) {
                request.orderIds = params.orderIds;
            }

            if (request.orderIds !== undefined) {
                this.sendRequest("/UnsuspendOrders.ashx", request, _unsuspendOrdersResponse);
            }

        }
    };

    var _unsuspendOrdersResponse = function (request, response) {

        if (response.returnCode != 0) {
            gecPrivate.checkExpiredSession(response.returnCode);
            request.callbackOnException.call(this, new gec.AsyncException(response));
        } else {
            if (request.orderIds) {
                var orderCache = gecPrivate._orderCache;

                request.orderIds.forEach(function (thisOrderRequest) {
                    if (orderCache[thisOrderRequest] !== undefined) {
                        orderCache[thisOrderRequest].orderStatusId = 1;// assume its active if it was previously suspended
                    }

                })
            }
            request.callbackOnSuccess.call(this, {});
        }
    };

    /****************************
    listExchangeMarketInformation
    ****************************/
    gec.Controller.prototype.listExchangeMarketInformation = function (params) {
        if ((gecPrivate.controllerDefaults == null) && (gecPrivate.userContext == null)) {
            request.callbackOnException.call(this, { returnCode: 591 });
        }
        else {
            var request = new gec.IAPIRequest(params);
            request.sessionToken = gecPrivate.sessionToken;
            request.marketIds = params.marketIds

            this.sendRequest("/ListExchangeMarketInformation.ashx", request, _listExchangeMarketInformationResponse);
        }
    };
    var _listExchangeMarketInformationResponse = function (request, response) {
        if (response.returnCode != 0) {
            if (request.callbackOnException != null)
                request.callbackOnException.call(this, { returnCode: response.returnCode });
        } else {
            var returnObject = [];

            for (var marketI = 0; marketI < response.markets.length; marketI++) {
                if (gecPrivate._eventClassifiers[response.markets[marketI].eventClassifierId] == null) {
                    gecPrivate._eventClassifiers[response.markets[marketI].eventClassifierId] = {};
                    if (response.markets[marketI].eventClassifierFullName == null) response.markets[marketI].eventClassifierFullName = "unknown";
                }
                gecPrivate._eventClassifiers[response.markets[marketI].eventClassifierId].eventClassifierId = response.markets[marketI].eventClassifierId;
                gecPrivate._eventClassifiers[response.markets[marketI].eventClassifierId].eventClassifierFullName = response.markets[marketI].eventClassifierFullName;

                if (gecPrivate._markets[response.markets[marketI].marketId] == null) {
                    gecPrivate._markets[response.markets[marketI].marketId] = {};
                }
                gecPrivate._markets[response.markets[marketI].marketId].marketId = response.markets[marketI].marketId;
                gecPrivate._markets[response.markets[marketI].marketId].marketName = response.markets[marketI].marketName;
                gecPrivate._markets[response.markets[marketI].marketId].eventClassifier = gecPrivate._eventClassifiers[response.markets[marketI].eventClassifierId];

                if (gecPrivate._markets[response.markets[marketI].marketId].selections == null) {
                    gecPrivate._markets[response.markets[marketI].marketId].selections = response.markets[marketI].selections;
                }

                for (var selectionI = 0; selectionI < response.markets[marketI].selections.length; selectionI++) {
                    if (gecPrivate._selections[response.markets[marketI].selections[selectionI].selectionId] == null) {
                        gecPrivate._selections[response.markets[marketI].selections[selectionI].selectionId] = {};
                    }
                    gecPrivate._selections[response.markets[marketI].selections[selectionI].selectionId].selectionName = response.markets[marketI].selections[selectionI].selectionName;
                }
            }

            request.callbackOnSuccess.call(this, returnObject);
        }
    };


    /**************************

    AAPI Calls for Push Services
    **************************/
    gec.Controller.prototype.subscribeExchangeMarket = function (params) {
        var request = new AAPIRequest(params);


        request.eventClassifierId = params.eventClassifierId;
        request.marketTypesToExclude = params.marketTypesToExclude;
        request.marketTypesToInclude = params.marketTypesToInclude;
        request.wantIndirectMarkets = params.wantIndirectMarkets;
        request.fetchOnly = params.fetchOnly;

    };
    var _subscribeExchangeMarketResponse = function (request, response) {



        //optionals
        if (request.fireOnSubscribedExchangeMarketITL != null)
            request.fireOnSubscribedExchangeMarketITL.call(this);

        if (request.fireOnSubscribedExchangeSelectionITL != null)
            request.fireOnSubscribedExchangeSelectionITL.call(this);

        if (request.fireOnSubscribedMarketScoresITL != null)
            request.fireOnSubscribedMarketScoresITL.call(this);

        if (request.fireOnSubscribedExchangeMarketDelta != null)
            request.fireOnSubscribedExchangeMarketDelta.call(this);

        if (request.fireOnSubscribedExchangeSelectionDelta != null)
            request.fireOnSubscribedExchangeSelectionDelta.call(this);

        if (request.fireOnSubscribedMarketScoresDelta != null)
            request.fireOnSubscribedMarketScoresDelta.call(this);

        if (request.fireOnITLCycleComplete != null)
            request.fireOnITLCycleComplete.call(this);



        request.callbackOnSuccess.call(this, response);

    };

    /****************************
    getExchangeEvent
    ****************************/
    gec.Controller.prototype.getExchangeEvent = function (params) {
        if ((gecPrivate.controllerDefaults == null) && (gecPrivate.userContext == null)) {
            params.callbackOnException.call(this, { returnCode: 591, message: "DefaultsNotLoaded" });;

        }
        else {
            var request = new gec.IAPIRequest(params);

            request.eventClassifierId = params.eventClassifierId;
            request.wantIndirectDescendents = params.wantIndirectDescendents;
            request.wantMultiplesOnly = params.wantMultiplesOnly;

            if (gecPrivate.userContext != null) {
                request.sessionToken = gecPrivate.sessionToken;
                request.language = gecPrivate.userContext.language;
                request.integrationPartnerId = gecPrivate.userContext.integrationPartnerId;
            }
            else //use defaults
            {
                request.language = gecPrivate.controllerDefaults.language;
                request.integrationPartnerId = gecPrivate.controllerDefaults.integrationPartnerId;
            }

            this.sendRequest("/ListExchangeMarkets.ashx", request, _getExchangeEventResponse);
        }

    };
    var _getExchangeEventResponse = function (request, response) {
        if (response.returnCode === 0) {
            delete response.returnCode;

            for (var i = 0; i < response.eventClassifiers.length; i++) {
                var responseEvent = response.eventClassifiers[i];

                gecPrivate._eventClassifiers[responseEvent.eventClassifierId] = gecPrivate._eventClassifiers[responseEvent.eventClassifierId] || new gec.EventClassifier();

                var thisEvent = gecPrivate._eventClassifiers[responseEvent.eventClassifierId];

                thisEvent.eventClassifierId = responseEvent.eventClassifierId;
                thisEvent.eventClassifierName = responseEvent.name;
                thisEvent.shortcutAllMarkets = responseEvent.shortcutAllMarkets;
                thisEvent.isEnabledForMultipleBets = responseEvent.isEnabledForMultipleBets;

                thisEvent._parentEventClassifierId = responseEvent.parentEventClassifierId;
                thisEvent.displayOrder = responseEvent.displayOrder;
                thisEvent.marketTypeIds = [];
                thisEvent.keep = true;


                for (marketTypeCount in responseEvent.marketTypes) {
                    thisEvent.marketTypeIds[marketTypeCount] = responseEvent.marketTypes[marketTypeCount];
                }

                (function (thisEvent) {
                    gecPrivate._eventClassifiers[thisEvent.eventClassifierId].getChildren = function () {
                        if (gecPrivate._eventClassifiers[thisEvent.eventClassifierId] == null) return [];
                        return _fillEvents(gecPrivate._eventClassifiers[thisEvent.eventClassifierId].eventClassifierId);
                    }
                    gecPrivate._eventClassifiers[thisEvent.eventClassifierId].getParent = function () {
                        if (gecPrivate._eventClassifiers[thisEvent.eventClassifierId] != null)//may have completed
                            return gecPrivate._eventClassifiers[gecPrivate._eventClassifiers[thisEvent.eventClassifierId]._parentEventClassifierId];
                        else
                            return null;
                    }
                    gecPrivate._eventClassifiers[thisEvent.eventClassifierId].getMarkets = function () {
                        if (_eventsMarkets[thisEvent.eventClassifierId] === undefined) {
                            return [];
                        }
                        else {
                            return _eventsMarkets[thisEvent.eventClassifierId].markets;
                        }
                    }
                })(thisEvent);


                _eventsMarkets[thisEvent.eventClassifierId] = {};
                _eventsMarkets[thisEvent.eventClassifierId].markets = [];
            }
            var eventIdIndex = {};
            eventIdIndex[request.eventClassifierId] = true;

            for (ev in gecPrivate._eventClassifiers) {

                if (gecPrivate._eventClassifiers[ev].eventClassifierName === "ROOT") {
                    delete gecPrivate._eventClassifiers[ev]; //remove whole object
                } else {
                    if (gecPrivate._eventClassifiers[ev].keep) {
                        delete gecPrivate._eventClassifiers[ev].keep; //remove keep property
                    } else {
                        if (GBEUtils.isDescendantOf(gecPrivate._eventClassifiers[ev], eventIdIndex)) {
                            delete _eventsMarkets[gecPrivate._eventClassifiers[ev].eventClassifierId];
                            delete gecPrivate._eventClassifiers[ev]; //remove whole object
                        }

                    }
                }
            }

            if (response.markets != null) {
                for (i = 0; i < response.markets.length; i++) {
                    var thisMarket = new gec.Market();
                    var responseMarket = response.markets[i];
                    thisMarket.marketId = responseMarket.marketId;
                    thisMarket.marketName = responseMarket.name;
                    thisMarket.marketType = responseMarket.marketType;
                    thisMarket.willBeInRunning = responseMarket.willBeInRunning;
                    thisMarket.currentlyInRunning = responseMarket.currentlyInRunning;
                    thisMarket.isEnabledForMultipleBets = responseMarket.isEnabledForMultipleBets;
                    thisMarket.isEnabledForEachWayBetting = responseMarket.isEnabledForEachWayBetting;
                    thisMarket.isEnabledForSPBetting = responseMarket.isEnabledForSPBetting;
                    thisMarket.startTime = responseMarket.startTime;
                    thisMarket.keep = true; //temp value to be removed later

                    (function (responseMarket) {
                        thisMarket.getEventClassifier = function () {
                            return gecPrivate._eventClassifiers[responseMarket.parentEventClassifierId];
                        };
                    })(responseMarket);

                    thisMarket.displayOrder = responseMarket.displayOrder;

                    gecPrivate._markets[thisMarket.marketId] = thisMarket;

                    _eventsMarkets[responseMarket.parentEventClassifierId].markets[_eventsMarkets[responseMarket.parentEventClassifierId].markets.length] = gecPrivate._markets[thisMarket.marketId];

                }
            }
            for (mk in gecPrivate._markets) {
                if (gecPrivate._markets[mk].keep) {
                    delete gecPrivate._markets[mk].keep; //remove keep property
                } else {

                    if (gecPrivate._markets[mk].getEventClassifier() !== undefined) {
                        var eventId = gecPrivate._markets[mk].getEventClassifier().eventClassifierId;

                        if (_eventsMarkets[eventId]) {
                            var m = _eventsMarkets[eventId].markets.length;
                            while (m--) {

                                if (_eventsMarkets[eventId].markets[m].marketId == mk) {
                                    _eventsMarkets[eventId].markets.splice(m, 1);
                                }
                            }
                        }

                    }

                    delete gecPrivate._markets[mk]; //remove whole object
                }
            }

            if (request.callbackOnSuccess != null)
                request.callbackOnSuccess.call(this, response);
        } else {
            request.callbackOnException.call(this, new gec.AsyncException({ returnCode: response.returnCode }));
        }

    };


    /****************************
   listOrders
   ****************************/
    gec.Controller.prototype.listOrders = function (params) {
        if (gecPrivate.userContext !== null) {
            var request = new gec.IAPIRequest(params);
            request.sessionToken = gecPrivate.sessionToken;

            request.includeFullyMatched = params.includeFullyMatched;
            request.includeFullyUnmatched = params.includeFullyUnmatched;
            request.includeSuspended = params.includeSuspended;
            request.includeUnsuspended = params.includeUnsuspended;
            request.validFromFilter = params.validFromFilter;
            request.validToFilter = params.validToFilter;
            request.orderStatusFilter = params.orderStatusFilter;
            request.settledFromFilter = params.settledFromFilter;
            request.settledToFilter = params.settledToFilter;
            request.orderById = params.orderById;
            //request.offset = {};
            request.startOffset = params.startOffset;
            request.numberToReturn = params.numberToReturn;
            if (params.minUnmatchedAmount !== null) {
                request.minUnmatchedAmount = {};
                request.minUnmatchedAmount.amount = params.minUnmatchedAmount;
                request.minUnmatchedAmount.currency = null;
            }
            if (params.minMatchedAmount !== null) {
                request.minMatchedAmount = {};
                request.minMatchedAmount.amount = params.minMatchedAmount;
                request.minMatchedAmount.currency = null;
            }
            this.sendRequest("/ListOrders.ashx", request, _listOrdersResponse);
        }
        else {
            request.callbackOnException.call(this, { returnCode: 590 });
        }

    };
    var _listOrdersResponse = function (request, response) {

        if (response.returnCode != 0) {
            request.callbackOnException.call(this, { returnCode: response.returnCode });

        } else {
            var orders = [];
            if ((response.returnCode == 0) && (response.totalResultSetSize > 0)) {

                for (var orderI = 0; orderI < response.orders.length; orderI++) {
                    var responseOrder = response.orders[orderI];
                    var orderObject = new gec.OrderDetail();
                    (function (responseOrder) {

                        orderObject.orderId = responseOrder.orderId;
                        orderObject.eventClassifierFullName = function () { return responseOrder.eventClassifierName; };
                        orderObject.marketId = responseOrder.marketId;
                        orderObject.marketName = responseOrder.marketName;
                        orderObject.selectionId = responseOrder.selectionId;
                        orderObject.selectionName = responseOrder.selectionName;
                        orderObject.issuedAt = responseOrder.issuedAt;
                        orderObject.lastChangedAt = responseOrder.lastChangedAt;
                        orderObject.expiresAt = responseOrder.expiresAt;
                        orderObject.validFrom = responseOrder.validFrom;
                        orderObject.orderFillType = responseOrder.orderFillType;
                        orderObject.fillOrKillThreshold = responseOrder.fillOrKillThreshold.amount;
                        orderObject.marketType = responseOrder.marketType;
                        orderObject.orderStatusId = responseOrder.status;
                        orderObject.requestedStake = responseOrder.requestedForSideStake.amount;
                        orderObject.requestedPrice = responseOrder.requestedForSidePrice;
                        orderObject.requestedAveragePrice = responseOrder.requestedAverageForSidePrice;
                        orderObject.expectedSelectionResetCount = responseOrder.expectedSelectionResetCount;
                        orderObject.expectedWithdrawalSequenceNumber = responseOrder.expectedWithdrawalSequenceNumber;
                        orderObject.isFreeBet = responseOrder.isFreeBet;

                        //if (!responseOrder.polarity) {
                        orderObject.matchedStake = responseOrder.totalForSideStake.amount;
                        //}
                        ////else {
                        //    orderObject.matchedStake = responseOrder.totalAgainstSideStake.amount;
                        //}
                        orderObject.unmatchedStake = responseOrder.forSideAmountUnmatched.amount;
                        orderObject.averageMatchedPrice = responseOrder.averageForSidePrice;
                        orderObject.matchingTimestamp = responseOrder.matchingTimestamp;
                        orderObject.polarityId = responseOrder.polarity;

                        orders[orders.length] = orderObject;
                    })(responseOrder);
                }
            }
            if (typeof request.numberToReturn !== "undefined" || (typeof request.numberToReturn !== "undefined" && request.numberToReturn !== null)) {
                request.callbackOnSuccess.call(this, { orders: orders, totalResultSetSize: response.totalResultSetSize });
            } else {
                request.callbackOnSuccess.call(this, orders);
            }
        }
    };

    /****************************
    getExchangePrices
    ****************************/
    gec.Controller.prototype.getExchangePrices = function (params) {
        if ((gecPrivate.controllerDefaults == null) && (gecPrivate.userContext == null)) {
            request.callbackOnException.call(this, { returnCode: 591 });
        }
        else {
            var requiredParams = {
                thresholdAmount: 1,
                wantIcons: true,
                justRefreshPrices: true,
                numberForPricesRequired: 1,
                numberAgainstPricesRequired: 1
            };

            var request = new gec.IAPIRequest(params, requiredParams);
            var currencyCode = params.currency || gecPrivate.controllerDefaults.currency;
            request.callbackOnException = params.callbackOnException;
            request.callbackOnSuccess = params.callbackOnSuccess;

            if (gecPrivate.userContext != null) {
                request.sessionToken = gecPrivate.sessionToken;
            }
            else //use defaults
            {
                request.language = gecPrivate.controllerDefaults.language;
                request.integrationPartnerId = gecPrivate.controllerDefaults.integrationPartnerId;
                request.currency = gecPrivate.controllerDefaults.currency;
            }
            request.currency = currencyCode;
            request.priceFormat = gecPrivate.controllerDefaults.priceFormat;
            request.wantIcons = params.wantIcons;
            request.justRefreshPrices = params.justRefreshPrices;
            request.thresholdAmount = { amount: params.thresholdAmount, currency: currencyCode };
            request.numberForPricesRequired = params.numberForPricesRequired;
            request.numberAgainstPricesRequired = params.numberAgainstPricesRequired;
            request.playMarkets = params.playMarkets;
            request.wantMarketDescription = params.wantMarketDescription;
            request.wantTabInformation = params.wantTabInformation;
            request.maxNoOfSelectionsToReturn = params.maxNoOfSelectionsToReturn;
            request.contextEvents = params.contextEvents;

            if (params.eventClassifierId != null) {
                request.eventClassifierId = params.eventClassifierId;
                request.marketType = params.marketTypeId;
            }
            else {
                if (params.eventClassifier != undefined) {
                    request.eventClassifierId = params.eventClassifier.eventClassifierId;
                    request.marketType = params.marketTypeId;
                } else {
                    request.marketIds = [];
                    if (params.markets != undefined) {
                        for (var i = 0; i < params.markets.length; i++) { request.marketIds[i] = params.markets[i].marketId; }
                    }
                    else {
                        if (params.selectionIds !== undefined) {
                            request.selectionIds = params.selectionIds;
                        }
                        request.marketIds = params.marketIds;
                    }
                }
            }
            this.sendRequest("/GetExchangePrices.ashx", request, getExchangePricesResponse, getExchangePricesXHR);
        }
    };
    var getExchangePricesResponse = function (request, response) {


        if (response.returnCode != 0) {
            gecPrivate.checkExpiredSession(response.returnCode);
            request.callbackOnException.call(this, { returnCode: response.returnCode });
        } else {
            var marketArrays = [];
            var marketI = 0;

            response.markets = response.markets.filter(function (market) {
                return (market.returnCode !== 16);
            });

            for (var i = 0; i < response.markets.length; i++) {
                var thisMarket = new gec.MarketDetail();
                var responseMarket = response.markets[i];
                var cachedMarket = gecPrivate._markets[responseMarket.marketId];
                if (cachedMarket == null) cachedMarket = {};

                thisMarket.marketId = responseMarket.marketId;

                if (response.markets[i].returnCode == 16) {
                    thisMarket.marketStatusId = 4;
                    thisMarket.totalMatchedAmount = 0;
                    marketArrays[marketI++] = thisMarket;
                }

                if (response.markets[i].returnCode == 0) {

                    //optional
                    if (responseMarket.marketDescription) {
                        thisMarket.marketDescription = responseMarket.marketDescription;
                    }

                    thisMarket.ancestryChain = responseMarket.ancestryChain || response.ancestryChain;
                    thisMarket.previousEventClassifier = response.previousEventClassifier;
                    thisMarket.nextEventClassifier = response.nextEventClassifier;

                    if (i === 0 && response.tabs) {
                        thisMarket.tabs = response.tabs;

                        if (responseMarket.parentEventClassifierId > 0) {
                            var eventTabs = getOrCreateEventTabs(responseMarket.parentEventClassifierId);

                            response.tabs.forEach(function (tab, tabIndex) {

                                tab.marketIds = tab.marketIds.split("~");
                                tab.marketIds.forEach(function (x, y, z) { z[y] = x | 0 }); // convert to numbers
                                eventTabs.addTab(tabIndex, tab);

                            });



                        }

                    }

                    if (responseMarket.parentEventClassifierId > 0)
                        thisMarket.eventClassifierId = responseMarket.parentEventClassifierId;

                    if (responseMarket.eventClassifierFullName)
                        thisMarket.eventClassifierFullName = responseMarket.eventClassifierFullName;

                    if (responseMarket.name)
                        thisMarket.marketName = responseMarket.name;
                    thisMarket.marketType = responseMarket.type;

                    thisMarket.displayOrder = responseMarket.displayOrder;

                    thisMarket.willBeInRunning = responseMarket.isInRunningAllowed;
                    thisMarket.isCurrentlyInRunning = responseMarket.isCurrentlyInRunning;
                    thisMarket.inRunningDelaySeconds = responseMarket.inRunningDelaySeconds;
                    thisMarket.isEnabledForMultipleBets = (responseMarket.isEnabledForMultiples) ? responseMarket.isEnabledForMultiples : cachedMarket.isEnabledForMultipleBets;
                    thisMarket.isEnabledForEachWayBetting = responseMarket.isEnabledForEachWayBetting;
                    thisMarket.isEnabledForSPBetting = responseMarket.isEnabledForSPBetting;
                    thisMarket.startTime = responseMarket.startTime;
                    thisMarket.suspendTime = responseMarket.suspendTime;

                    thisMarket.managedWhenInRunning = responseMarket.managedWhenInRunning;

                    //thisMarket.getEventClassifier = function () { return gecPrivate._eventClassifiers[responseMarket.parentEventClassifierId]; };

                    if (responseMarket.selectionIconsURL) {
                        thisMarket.selectionIconsURL = responseMarket.selectionIconsURL;
                        thisMarket.iconWidth = responseMarket.iconWidth;
                        thisMarket.iconHeight = responseMarket.iconHeight;
                    }


                    thisMarket.placePayout = responseMarket.placePayout;

                    thisMarket.numberOfWinningSelections = responseMarket.numberOfWinningSelections;

                    thisMarket.marketStatusId = responseMarket.status;
                    thisMarket.withdrawalSequenceNumber = responseMarket.withdrawalSequenceNumber;

                    if (responseMarket.totalMatchedAmount != null)
                        thisMarket.totalMatchedAmount = responseMarket.totalMatchedAmount.amount;

                    responseMarket.selections.sort(gec.SortOnDisplayOrder);

                    for (var j = 0; j < responseMarket.selections.length; j++) {
                        var thisSelection = responseMarket.selections[j];
                        thisMarket.selections[j] = new gec.SelectionDetail();
                        thisMarket.selections[j].selectionId = thisSelection.selectionId;
                        thisMarket.selections[j].selectionName = thisSelection.name;
                        thisMarket.selections[j].selectionIconIndex = thisSelection.selectionIconIndex;
                        thisMarket.selections[j].selectionBlurb = thisSelection.selectionBlurb;
                        thisMarket.selections[j].selectionStatusId = thisSelection.status;
                        thisMarket.selections[j].selectionResetCount = thisSelection.selectionResetCount;
                        thisMarket.selections[j].withdrawalFactor = thisSelection.selectionDeductionFactor;

                        //thisMarket.selections[j].displayOrder = response.markets[i].selections[j].displayOrder;

                        for (var forPriceCount = 0; forPriceCount < thisSelection.forSidePrices.length; forPriceCount++) {
                            thisMarket.selections[j].forExchangePrices[forPriceCount] = new gec.ExchangePrice();
                            thisMarket.selections[j].forExchangePrices[forPriceCount].price = thisSelection.forSidePrices[forPriceCount].price;
                            thisMarket.selections[j].forExchangePrices[forPriceCount].displayPrice = thisSelection.forSidePrices[forPriceCount].displayPrice;
                            thisMarket.selections[j].forExchangePrices[forPriceCount].amountAvailable = gecPrivate._base.formatDecimal(thisSelection.forSidePrices[forPriceCount].stake.amount, 0, "");
                            thisMarket.selections[j].forExchangePrices[forPriceCount].hasRecentlyChanged = true;

                        }
                        for (var againstPriceCount = 0; againstPriceCount < thisSelection.againstSidePrices.length; againstPriceCount++) {
                            thisMarket.selections[j].againstExchangePrices[againstPriceCount] = new gec.ExchangePrice();
                            thisMarket.selections[j].againstExchangePrices[againstPriceCount].price = thisSelection.againstSidePrices[againstPriceCount].price;
                            thisMarket.selections[j].againstExchangePrices[againstPriceCount].displayPrice = thisSelection.againstSidePrices[againstPriceCount].displayPrice;
                            thisMarket.selections[j].againstExchangePrices[againstPriceCount].amountAvailable = gecPrivate._base.formatDecimal(thisSelection.againstSidePrices[againstPriceCount].stake.amount, 0, "");
                            thisMarket.selections[j].againstExchangePrices[againstPriceCount].hasRecentlyChanged = true;
                        }

                        thisMarket.selections[j].market = thisMarket;
                        gecPrivate._selections[thisMarket.selections[j].selectionId] = thisMarket.selections[j];
                    }

                    marketArrays[marketI++] = thisMarket;
                }
            }
            request.callbackOnSuccess.call(this, marketArrays);
        }
    };

    /****************************
    getExchangePricesEnhanced
    ****************************/
    gec.Controller.prototype.getExchangePricesEnhanced = function (params) {
        if ((gecPrivate.controllerDefaults == null) && (gecPrivate.userContext == null)) {
            request.callbackOnException.call(this, { returnCode: 591 });
        }
        else {
            var currencyCode = params.currency || gecPrivate.controllerDefaults.currency;

            var request = new gec.IAPIRequest(params);
            request.callbackOnException = params.callbackOnException;
            request.callbackOnSuccess = params.callbackOnSuccess;

            if (gecPrivate.userContext != null) {
                request.sessionToken = gecPrivate.sessionToken;
            }
            else { //use defaults
                request.language = gecPrivate.controllerDefaults.language;
                request.integrationPartnerId = gecPrivate.controllerDefaults.integrationPartnerId;
                request.currency = currencyCode;
                request.priceFormat = gecPrivate.controllerDefaults.priceFormat;
            }

            request.marketId = params.marketId;
            request.thresholdAmount = { amount: params.thresholdAmount, currency: currencyCode };

            request.wantMarketDescription = params.wantMarketDescription;
            request.wantTabInformation = params.wantTabInformation;

            request.numberForPricesRequired = params.numberForPricesRequired;
            request.numberAgainstPricesRequired = params.numberAgainstPricesRequired;

            request.wantIcons = params.wantIcons;

            request.wantMultiplesOnly = params.wantMultiplesOnly;

            this.sendRequest("/GetExchangePricesEnhanced.ashx", request, _getExchangePricesEnhancedResponse);
        }
    };
    var _getExchangePricesEnhancedResponse = function (request, response) {
        if (response.returnCode != 0) {
            gecPrivate.checkExpiredSession(response.returnCode);
            request.callbackOnException.call(this, { returnCode: response.returnCode });
        } else {
            // TODO: NB - This check can be removed when IAPI work outlined in #47844 has been completed...
            if (response.status === 0) {
                request.callbackOnException.call(this, { returnCode: 16 });
            } else {
                var marketDetail = new gec.MarketDetail();

                marketDetail.marketId = response.marketId;
                marketDetail.eventClassifierId = response.parentEventClassifierId;
                marketDetail.eventClassifierAncestryChain = response.eventClassifierAncestryChain;
                marketDetail.eventClassifierFullName = response.eventClassifierFullName;
                marketDetail.marketName = response.name;
                marketDetail.isEnabledForMultipleBets = response.isEnabledForMultiples;
                if (response.marketDescription) {
                    marketDetail.marketDescription = response.marketDescription;
                }
                if (response.tabs) {
                    marketDetail.tabs = response.tabs;

                    marketDetail.tabs.forEach(function (val, index) {
                        val.marketIds = val.marketIds.split("~");
                    });
                }
                if (response.selectionIconsURL != null) {
                    marketDetail.selectionIconsURL = response.selectionIconsURL;
                    marketDetail.iconWidth = response.iconWidth;
                    marketDetail.iconHeight = response.iconHeight;
                }
                marketDetail.marketType = response.marketType;
                // TODO: isPlayMarket???
                marketDetail.placePayout = response.placePayout;
                marketDetail.willBeInRunning = response.isInRunningAllowed; // TODO: Same thing???
                //marketDetail.isInRunningAllowed = response.isInRunningAllowed;
                // TODO: dangerballBehaviour???
                // TODO: lastDangerballCheckpointAt???
                // TODO: wasRollback???
                marketDetail.managedWhenInRunning = response.managedWhenInRunning;
                marketDetail.inRunningDelaySeconds = response.inRunningDelaySeconds;
                if (response.totalMatchedAmount != null)
                    marketDetail.totalMatchedAmount = response.totalMatchedAmount.amount;
                // TODO: effectiveMarketTradingRestriction???
                marketDetail.isCurrentlyInRunning = response.isCurrentlyInRunning;
                // TODO: isMarketConfused???
                marketDetail.numberOfWinningSelections = response.numberOfWinningSelections;
                marketDetail.startTime = response.startTime;
                marketDetail.suspendTime = response.suspendTime;
                marketDetail.marketStatusId = response.status;
                marketDetail.withdrawalSequenceNumber = response.withdrawalSequenceNumber;
                marketDetail.isEnabledForEachWayBetting = response.isEnabledForEachWayBetting;
                marketDetail.isEnabledForSPBetting = response.isEnabledForSPBetting;
                //
                marketDetail.selections.sort(gec.SortOnDisplayOrder);

                var forPriceCount, againstPriceCount;
                for (var j = 0; j < response.selections.length; j++) {
                    var thisSelection = response.selections[j];
                    marketDetail.selections[j] = new gec.SelectionDetail();
                    marketDetail.selections[j].selectionId = thisSelection.selectionId;
                    marketDetail.selections[j].selectionName = thisSelection.name;
                    marketDetail.selections[j].selectionBlurb = thisSelection.selectionBlurb;
                    // TODO: selectionIcon???
                    marketDetail.selections[j].selectionIconIndex = thisSelection.selectionIconIndex;
                    marketDetail.selections[j].selectionStatusId = thisSelection.status;
                    marketDetail.selections[j].selectionResetCount = thisSelection.selectionResetCount;
                    marketDetail.selections[j].withdrawalFactor = thisSelection.selectionDeductionFactor;

                    //
                    for (forPriceCount = 0; forPriceCount < thisSelection.forSidePrices.length; forPriceCount++) {
                        marketDetail.selections[j].forExchangePrices[forPriceCount] = new gec.ExchangePrice();
                        marketDetail.selections[j].forExchangePrices[forPriceCount].price = thisSelection.forSidePrices[forPriceCount].price;
                        marketDetail.selections[j].forExchangePrices[forPriceCount].displayPrice = thisSelection.forSidePrices[forPriceCount].displayPrice;
                        marketDetail.selections[j].forExchangePrices[forPriceCount].amountAvailable = gecPrivate._base.formatDecimal(thisSelection.forSidePrices[forPriceCount].stake.amount, 0, "");
                        marketDetail.selections[j].forExchangePrices[forPriceCount].hasRecentlyChanged = true;
                    }

                    //
                    for (againstPriceCount = 0; againstPriceCount < thisSelection.againstSidePrices.length; againstPriceCount++) {
                        marketDetail.selections[j].againstExchangePrices[againstPriceCount] = new gec.ExchangePrice();
                        marketDetail.selections[j].againstExchangePrices[againstPriceCount].price = thisSelection.againstSidePrices[againstPriceCount].price;
                        marketDetail.selections[j].againstExchangePrices[againstPriceCount].displayPrice = thisSelection.againstSidePrices[againstPriceCount].displayPrice;
                        marketDetail.selections[j].againstExchangePrices[againstPriceCount].amountAvailable = gecPrivate._base.formatDecimal(thisSelection.againstSidePrices[againstPriceCount].stake.amount, 0, "");
                        marketDetail.selections[j].againstExchangePrices[againstPriceCount].hasRecentlyChanged = true;
                    }

                    marketDetail.selections[j].market = marketDetail;
                }

                request.callbackOnSuccess.call(this, {
                    marketDetail: marketDetail,
                    topLevelEventClassifierId: response.topLevelEventClassifierId,
                    grandparentEventClassifierId: response.grandparentEventClassifierId,
                    relatedEventClassifiers: response.relatedEventClassifiers,
                    relatedMarkets: response.relatedMarkets
                });
            }
        }
    };

    /****************************
    getExchangeMarketsBlurb
    ****************************/
    gec.Controller.prototype.getExchangeMarketsBlurb = function (params) {
        if ((gecPrivate.controllerDefaults == null) && (gecPrivate.userContext == null)) {
            request.callbackOnException.call(this, new gec.AsyncException({ returnCode: 591 }));
        }
        else {
            var request = new gec.IAPIRequest(params);
            request.sessionToken = gecPrivate.sessionToken;

            if (params.markets != null) {
                request.eventClassifierId = null;
                request.marketIds = []; //:Array;
                for (var i = 0; i < params.markets.length; i++) {
                    request.marketIds[i] = params.markets[i].marketId;
                }
            }
            else if (params.eventClassifier != null) {
                request.eventClassifierId = params.eventClassifier.eventClassifierId;
                request.playMarkets = params.playMarkets;
                request.marketType = params.marketTypeId;
            }
            else { request.marketIds = params.marketIds; }

            if (gecPrivate.userContext !== null) {
                request.integrationPartnerId = gecPrivate.userContext.integrationPartnerId;
                request.language = gecPrivate.userContext.language;
            }
            else //use defaults
            {
                request.integrationPartnerId = gecPrivate.controllerDefaults.integrationPartnerId;
                request.language = gecPrivate.controllerDefaults.language;
            }
            request.playMarkets = params.playMarkets;
            this.sendRequest("/GetExchangeMarketsBlurb.ashx", request, _getExchangeMarketsBlurbResponse);
        }
    };
    var _getExchangeMarketsBlurbResponse = function (request, response) {
        if (response.returnCode != 0) {
            gecPrivate.checkExpiredSession(response.returnCode);
            request.callbackOnException.call(this, new gec.AsyncException(response));
        } else {
            var markets = [];

            for (var market = 0; market < response.markets.length; market++) {
                var thisMarket = response.markets[market];
                thisMarket.eventClassifierFullName = response.markets[market].eventClassifierFullName;
                markets[markets.length] = thisMarket;
            }
            request.callbackOnSuccess.call(this, markets);
        }

    };

    /****************************
    getExchangeMarketsHistory
    ****************************/
    gec.Controller.prototype.getExchangeMarketsHistory = function (params) {
        if ((gecPrivate.userContext == null) && (gecPrivate.controllerDefaults == null)) {

            request.callbackOnException.call(this, { returnCode: 591 });
        }
        else {
            var request = new gec.IAPIRequest(params);

            if (gecPrivate.sessionToken != null) {
                request.sessionToken = gecPrivate.sessionToken;
            }
            else {

                request.currency = gecPrivate.controllerDefaults.currency;
                request.language = gecPrivate.controllerDefaults.language;
                request.priceFormat = gecPrivate.controllerDefaults.priceFormat;

                if (gecPrivate.controllerDefaults.integrationPartnerId != null) {
                    request.integrationPartnerId = gecPrivate.controllerDefaults.integrationPartnerId;
                }
            }

            if (params.marketIds != null)
                request.marketIds = params.marketIds
            else {
                request.marketIds = [];
                for (var marketCount = 0; marketCount < params.markets.length; marketCount++) {
                    request.marketIds[request.marketIds.length] = params.markets[marketCount].marketId;
                }
            }
            this.sendRequest("/GetExchangeMarketsHistory.ashx", request, _getExchangeMarketsHistoryResponse);
        }
    };
    var _getExchangeMarketsHistoryResponse = function (request, response) {
        if (response.returnCode != 0) {
            gecPrivate.checkExpiredSession(response.returnCode);
            request.callbackOnException.call(this, { returnCode: response.returnCode });
        } else {

            var markets = [];
            if (response.markets != null) {
                for (var marketCount = 0; marketCount < response.markets.length; marketCount++) {
                    var thisMarket = {};
                    thisMarket.marketId = response.markets[marketCount].marketId;
                    thisMarket.marketType = response.markets[marketCount].type;
                    thisMarket.marketName = response.markets[marketCount].name;
                    thisMarket.eventClassifierFullName = response.markets[marketCount].eventClassifierFullName;
                    thisMarket.marketStatusId = response.markets[marketCount].status;

                    var selections = [];
                    for (var selectionCount = 0; selectionCount < response.markets[marketCount].selections.length; selectionCount++) {
                        var thisSelection = {};
                        thisSelection.selectionId = response.markets[marketCount].selections[selectionCount].selectionId;
                        thisSelection.selectionName = response.markets[marketCount].selections[selectionCount].selectionName;
                        thisSelection.selectionStatusId = response.markets[marketCount].selections[selectionCount].status;

                        var matches = [];
                        if (response.markets[marketCount].selections[selectionCount].matches != null) {
                            for (var matchCount = 0; matchCount < response.markets[marketCount].selections[selectionCount].matches.length; matchCount++) {
                                var thisMatch = {};

                                thisMatch.matchedAmount = response.markets[marketCount].selections[selectionCount].matches[matchCount].matchedAmount.amount;
                                thisMatch.time = response.markets[marketCount].selections[selectionCount].matches[matchCount].time;
                                thisMatch.matchedPrice = response.markets[marketCount].selections[selectionCount].matches[matchCount].matchedPrice;
                                thisMatch.formattedPrice = response.markets[marketCount].selections[selectionCount].matches[matchCount].formattedPrice;

                                matches[matches.length] = thisMatch;
                            }
                        }
                        thisSelection.matches = matches;
                        selections[selections.length] = thisSelection;
                    }
                    thisMarket.selections = selections;
                    markets[markets.length] = thisMarket;
                }
            }
            request.callbackOnSuccess.call(this, markets);
        }
    };

    /****************************
    getExchangeAggregatedMatchHistory
    ****************************/
    gec.Controller.prototype.getExchangeAggregatedMatchHistory = function (params) {

        var request = new gec.IAPIRequest(params);

        if (gecPrivate.sessionToken != null)
            request.sessionToken = gecPrivate.sessionToken;
        else {
            request.integrationPartnerId = gecPrivate.controllerDefaults.integrationPartnerId;
            request.currency = gecPrivate.controllerDefaults.currency;
            request.priceFormat = gecPrivate.controllerDefaults.priceFormat;
        }

        request.language = gecPrivate.controllerDefaults.language;

        request.selectionIds = params.selectionIds;
        request.minimumMatchedAmount = {
            currency: gecPrivate.userContext != null ? gecPrivate.userContext.currency : gecPrivate.controllerDefaults.currency,
            amount: params.minimumMatchedAmount
        }

        this.sendRequest("/GetExchangeAggregatedMatchHistory.ashx", request, _getExchangeAggregatedMatchHistoryResponse);

    }

    var _getExchangeAggregatedMatchHistoryResponse = function (request, response) {

        if (response.returnCode === 0) {
            request.callbackOnSuccess.call(this, response.selections);
        } else {
            request.callbackOnException.call(this, new gec.AsyncException({
                returnCode: response.returnCode
            }));
        }

    };



    gec.Controller.prototype.getOrder = function (params) {

        if (gecPrivate._orderCache !== null) {
            return gecPrivate._orderCache[params.orderId];
        }
        else
            throw { "number": 592, "message": "OrderCacheNotPresent" };
    };
    /****************************
    getOrderDetails
    ****************************/
    gec.Controller.prototype.getOrderDetails = function (params) {
        if (gecPrivate.userContext !== null) {
            var request = new gec.IAPIRequest(params);
            request.sessionToken = gecPrivate.sessionToken;
            request.orderId = params.orderId;

            this.sendRequest("/GetOrderDetails.ashx", request, _getOrderDetailsResponse);
        }
        else {
            params.callbackOnException({ returnCode: 590 });
        }
    };
    var _getOrderDetailsResponse = function (request, response) {

        if (response.returnCode === 0) {
            var orderObject = new gec.OrderDetail();

            orderObject.orderId = request.orderId;
            orderObject.eventClassifierFullName = function () { return response.eventClassifierFullName; };
            orderObject.marketId = response.marketId;
            orderObject.marketName = response.marketName;
            orderObject.marketStatus = response.marketStatus;
            orderObject.selectionId = response.selectionId;
            orderObject.selectionName = response.selectionName;
            orderObject.issuedAt = response.issuedAt;
            orderObject.lastChangedAt = response.lastChangedAt;
            orderObject.expiresAt = response.expiresAt;
            orderObject.validFrom = response.validFrom;
            orderObject.orderFillType = response.orderFillType;
            orderObject.fillOrKillThreshold = response.fillOrKillThreshold.amount;
            orderObject.marketType = response.marketType * 1;
            orderObject.orderStatusId = response.orderStatus;
            orderObject.requestedStake = response.requestedStake.amount;
            orderObject.requestedPrice = response.requestedPrice;
            orderObject.requestedAveragePrice = response.requestedAveragePrice;
            orderObject.expectedSelectionResetCount = response.expectedSelectionResetCount;
            orderObject.expectedWithdrawalSequenceNumber = response.expectedWithdrawalSequenceNumber;
            orderObject.isFreeBet = response.isFreeBet;

            orderObject.matchedStake = response.totalStake.amount;
            orderObject.unmatchedStake = response.unmatchedStake.amount;
            orderObject.averageMatchedPrice = response.averagePrice;
            orderObject.matchingTimestamp = response.matchingTimestamp;
            orderObject.polarityId = response.polarity;
            orderObject.withdrawRepriceOption = response.withdrawRepriceOption;
            orderObject.cancelOnInRunning = response.cancelOnInRunning;
            orderObject.cancelIfSelectionReset = response.cancelIfSelectionReset;
            orderObject.sequenceNumber = response.sequenceNumber;
            if (response.grossSettlementAmount != null)
                orderObject.grossSettlementAmount = response.grossSettlementAmount.amount;
            if (response.marketCommission != null)
                orderObject.marketCommission = response.marketCommission.amount;
            orderObject.marketSettledDate = response.marketSettledDate;


            if (response.orderCommission != null)
                orderObject.orderCommission = response.orderCommission.amount;
            if (response.marketCommission != null)
                orderObject.marketCommission = response.marketCommission.amount;

            //orderObject.commissionBasis = response.commissionBasis;
            orderObject.makeCommissionRate = response.makeCommissionRate;
            orderObject.takeCommissionRate = response.takeCommissionRate;


            if (response.orderPAndL != null)
                orderObject.orderPAndL = response.orderPAndL.amount;


            orderObject.totalForSideMakeStake = response.totalForSideMakeStake.amount;
            orderObject.totalForSideTakeStake = response.totalForSideTakeStake.amount;

            orderObject.history = [];
            if (response.auditLog != null) {
                for (var auditCount = 0; auditCount < response.auditLog.length; auditCount++) {
                    orderObject.history[auditCount] = new gec.OrderHistoryItem();
                    orderObject.history[auditCount].time = response.auditLog[auditCount].time;
                    orderObject.history[auditCount].orderActionTypeId = response.auditLog[auditCount].orderActionType;
                    orderObject.history[auditCount].requestedStake = response.auditLog[auditCount].requestedStake.amount;
                    orderObject.history[auditCount].requestedPrice = response.auditLog[auditCount].requestedPrice;

                    if (response.auditLog[auditCount].matchedStake != null)
                        orderObject.history[auditCount].matchedAgainstStake = response.auditLog[auditCount].matchedAgainstStake.amount;
                    else
                        orderObject.history[auditCount].matchedAgainstStake = 0;

                    orderObject.history[auditCount].priceMatched = response.auditLog[auditCount].priceMatched;
                    orderObject.history[auditCount].matchedOrderId = response.auditLog[auditCount].matchedOrderId;
                    orderObject.history[auditCount].totalMatchedStake = response.auditLog[auditCount].totalStake.amount;
                    //orderObject.history[auditCount].totalProvisionalMatchedStake  = response.auditLog[auditCount].totalProvisionalMatchedStake.amount;

                    orderObject.history[auditCount].totalAgainstStake = response.auditLog[auditCount].totalAgainstStake.amount;
                    orderObject.history[auditCount].averagePrice = response.auditLog[auditCount].averagePrice;
                    orderObject.history[auditCount].amountUnmatched = response.auditLog[auditCount].amountUnmatched.amount;
                    if (response.auditLog[auditCount].grossSettlementAmount != null)
                        orderObject.history[auditCount].grossSettlementAmount = response.auditLog[auditCount].grossSettlementAmount.amount;

                    if (response.auditLog[auditCount].orderPAndL != null)
                        orderObject.history[auditCount].orderPAndL = response.auditLog[auditCount].orderPAndL.amount;

                    if (response.auditLog[auditCount].totalStake != null)
                        orderObject.history[auditCount].totalMatchedStake = response.auditLog[auditCount].totalStake.amount;
                    else
                        orderObject.history[auditCount].totalMatchedStake = 0;

                    if (response.auditLog[auditCount].matchedStake != null)
                        orderObject.history[auditCount].matchedStake = response.auditLog[auditCount].matchedStake.amount;
                    else
                        orderObject.history[auditCount].matchedStake = 0;


                    if (response.auditLog[auditCount].wasMakeSpecified) {
                        orderObject.history[auditCount].wasMake = response.auditLog[auditCount].wasMake;
                    }
                    orderObject.history[auditCount].priceMatched = response.auditLog[auditCount].priceMatched;
                }
            }
            request.callbackOnSuccess.call(this, orderObject);
        }
        else {
            request.callbackOnException.call(this, { returnCode: response.returnCode });
        }

    };


    /****************************
    listMarketPAndL
    ****************************/
    gec.Controller.prototype.listMarketPAndL = function (params) {
        var request = new gec.IAPIRequest(params);

        request.sessionToken = gecPrivate.sessionToken;
        request.eventClassifierId = params.eventClassifierId;
        request.startTime = params.startTime;
        request.endTime = params.endTime;
        request.marketSettlementFlag = params.marketSettlementFlag;

        this.sendRequest("/ListMarketPAndL.ashx", request, _listMarketPAndLResponse);

    };
    var _listMarketPAndLResponse = function (request, response) {
        if (response.returnCode != 0) {
            request.callbackOnException.call(this, { returnCode: response.returnCode });
        } else {
            request.callbackOnSuccess.call(this, { orders: response.orders, totalResultSetSize: response.totalResultSetSize });
        }
    };

    /****************************
    listPAndLHierarchy
    ****************************/
    gec.Controller.prototype.listPAndLHierarchy = function (params) {
        var request = new gec.IAPIRequest(params);

        request.sessionToken = gecPrivate.sessionToken;

        request.eventClassifierId = params.eventClassifierId;
        request.startTime = params.startTime;
        request.endTime = params.endTime;

        this.sendRequest("/ListPAndLHierarchy.ashx", request, _listPAndLHierarchyResponse);

    };
    var _listPAndLHierarchyResponse = function (request, response) {

        var  outputEventClassifiers = [];

        if (response.returnCode != 0) {
            request.callbackOnException.call(this, {
                returnCode: response.returnCode
            });
        } else {

            if (response.events) {

                // Map IAPI output to GEC outputs (only differences are MoneyAmounts,
                // which are mapped to simple numbers)
                outputEventClassifiers = response.events.map(function(event) {
                    return {
                        eventClassifierId: event.eventClassifierId,
                        parentEventClassifierId: event.parentEventClassifierId,
                        eventClassifierName: event.eventClassifierName,
                        displayOrder: event.displayOrder,
                        eventClassifierFullName: event.eventClassifierFullName,
                        numberSettledOrders: event.numberSettledOrders,
                        grossSettlementAmount: event.grossSettlementAmount ? event.grossSettlementAmount.amount : event.grossSettlementAmount,
                        marketCommissionPaid: event.marketCommissionPaid ? event.marketCommissionPaid.amount : event.marketCommissionPaid
                    };
                });
            }

            request.callbackOnSuccess.call(this, {
                eventClassifiers: outputEventClassifiers
            });
        }
    };

    /****************************
    listMarketPAndLSummary
    ****************************/
    gec.Controller.prototype.listMarketPAndLSummary = function (params) {
        var request = new gec.IAPIRequest(params);

        request.sessionToken = gecPrivate.sessionToken;

        request.eventClassifierId = params.eventClassifierId;
        request.startTime = params.startTime;
        request.endTime = params.endTime;
        request.startOffset = params.startOffset;
        request.numberToReturn = params.numberToReturn;

        this.sendRequest("/ListMarketPAndLSummary.ashx", request, _listMarketPAndLSummaryResponse);

    };
    var _listMarketPAndLSummaryResponse = function (request, response) {

        var outputMarkets = [];

        if (response.returnCode != 0) {
            request.callbackOnException.call(this, {
                returnCode: response.returnCode
            });
        } else {

            if (response.markets) {

                // Map IAPI output to GEC outputs (only differences are MoneyAmounts,
                // which are mapped to simple numbers)
                outputMarkets = response.markets.map(function(market) {
                    return {
                        marketId: market.marketId,
                        marketName: market.marketName,
                        eventClassifierId: market.eventClassifierId,
                        eventClassifierName: market.eventClassifierName,
                        grossSettlementAmount: market.grossSettlementAmount ? market.grossSettlementAmount.amount : market.grossSettlementAmount,
                        marketCommissionPaid: market.marketCommissionPaid ? market.marketCommissionPaid.amount : market.marketCommissionPaid,
                        marketSettledDate: market.marketSettledDate
                    };
                });
            }

            request.callbackOnSuccess.call(this, {
                totalResultSetSize: response.totalResultSetSize,
                markets: outputMarkets
            });

        }
    };

    /****************************
    listSettledPAndL
    ****************************/
    gec.Controller.prototype.listSettledPAndL = function (params) {
        var request = new gec.IAPIRequest(params);

        request.sessionToken = gecPrivate.sessionToken;
        if (params.marketIds != null) {
            request.marketIds = params.marketIds;
        } else {
            if (params.markets && params.markets.length) {
                request.marketIds = []
                for (var i = 0; i < params.markets.length; i++) { request.marketIds[i] = params.markets[i].marketId; }
            }
        }

        request.eventClassifierIds = params.eventClassifierIds;
        request.eventClassifiers = params.eventClassifiers;
        request.marketType = params.marketType;
        request.playMarkets = params.playMarkets;

        this.sendRequest("/ListSettledPAndL.ashx", request, _listSettledPAndLResponse);

    };
    var _listSettledPAndLResponse = function (request, response) {
        if (response.returnCode != 0) {
            request.callbackOnException.call(this, { returnCode: response.returnCode });
        } else {
            request.callbackOnSuccess.call(this, { markets: response.markets });
        }
    };

    /****************************
    listPunterReservations
    ****************************/
    gec.Controller.prototype.listPunterReservations = function (params) {
        var request = new gec.IAPIRequest(params);
        request.sessionToken = gecPrivate.sessionToken;

        this.sendRequest("/ListPunterReservations.ashx", request, _listPunterReservationsResponse);

    };
    var _listPunterReservationsResponse = function (request, response) {
        if (response.returnCode != 0) {
            request.callbackOnException.call(this, { returnCode: response.returnCode });
        } else {
            request.callbackOnSuccess.call(this, { punterReservations: response.reservations });
        }
    };

    gec.Controller.prototype._addPushRegex = function (params) {
        gecPrivate._regexArray = params;
    }

    /*****************************
    PUSH calls
    ******************************/



    gec.Controller.prototype.unsubscribe = function (params) {
        var correlationId = gecPrivate.addToCorrelation(params);

        var request = {};
        request[0] = correlationId;

        if (params.subscriptionIds != null) {
            request[1] = "";
            for (var subI = 0; subI < params.subscriptionIds.length; subI++) {
                request[1] += params.subscriptionIds[subI] + "~";
            }
            request[1] = request[1].substr(0, request[1].length - 1);
        }

        gecPrivate.addToPushMessages(request);
        gecPrivate._sendStreamingMessage(20, request);
        return correlationId;
    };

    var _regexArrayExchange = [
        //Session Management Commands
        { regex: /^\S(\d{1,4})\/D\S9$/, method: _onSubscribeMarketInformation },
        {
            regex: /^.*\/E\/E_([0-9]*)\/M\/E_([0-9]*)$/, method: _onMarket1, converter: {
                1: "displayOrder",
                2: [{ 1: "occurredAt", 2: "score" }]
            }
        },
        {
            regex: /^.*\/E\/E_([0-9]*)$/, method: _onEvent1, converter: {
                1: "displayOrder",
                2: [{ 1: "occurredAt", 2: "score" }],
                3: [{ 1: "occurrenceType", 2: "predictedTime", 3: "actualTime" }]
            }
        },
        {
            regex: /^.*\/E\/E_([0-9]*)\/EEI$/, method: _onEExchangeInfo, converter: {
                1: "eventClassifierId",
                2: "isEnabledForMultiples",
                3: "startTime"
            }
        },
        {
            regex: /^.*\/E\/E_([0-9]*)\/EEI\/EEL\/([a-z\d\-\-]{2})$/, method: _onLanguage2, converter: {
                1: "name",
                2: "raceGrade"
            }
        },
        {
            regex: /^\S(\d{1,4})\/E\/E_([0-9]*)$/, method: _onMExchangeInfo, converter: {
                1: "marketId",
                2: "marketType",
                3: "isPlayMarket",
                4: "canBeInRunning",
                5: "managedWhenInRunning",
                6: "isVisibleAsTradingMarket",
                7: "isVisibleAsPricedMarket",
                8: "isEnabledForMultiples",
                9: "isCurrentlyInRunning",
                10: "status",
                11: "withdrawAction",
                12: "ballotOutAction",
                13: "canBeDeadHeated",
                14: "startTime",
                15: "delayFactor",
                16: "numberOfWinningSelections",
                17: "withdrawalSequenceNumber",
                18: "resultString",
                19: "numberOfSelections",
                20: "placePayout",
                21: "redboxSPAvailable",
                22: "bOGAvailable",
                23: "numberWinningPlaces",
                24: "placeFraction",
                25: "bettingTypeId"
            }
        },
        {
            regex: /^.*\/E\/E_([0-9]*)\/EEI\/TAB\/Tab(\d*)$/, method: _onTab, converter: {
                1: "displayOrder",
                2: "marketIds",
                3: "numberOfMarketsToExpand"
            }
        },
        {
            regex: /^.*\/E\/E_([0-9]*)\/EEI\/TAB\/Tab(\d*)\/TL\/([a-z\d\-\-]{2})$/, method: _onLanguage14, converter: {
                1: "name"
            }
        },
        {
            regex: /^\S(\d{1,4})\/E\/E_([0-9]*)$/, method: _onLanguage3, converter: {
                1: "name",
                2: "description",
                3: "marketBlurb"
            }
        },
        {///BrokerId/Events/Event1/EventLanguage/Language4
            regex: /^.*\/E\/E_([0-9]*)\/EL\/([a-z\d\-\-]{2})$/, method: _onLanguage4, converter: {
                1: "name"
            }
        },
        {///BrokerId/Events/Event1/Markets/Market1/MarketLanguage/Language7
            regex: /^\S(\d{1,4})\/E\/E_([0-9]*)$/, method: _onLanguage7, converter: {
                1: "name"
            }
        },
        {///BrokerId/Events/Event1/Markets/Market1/Selections/Selection1 
            regex: /^\S(\d{1,4})\/E\/E_([0-9]*)$/, method: _onSelection1, converter: {
                1: "displayOrder",
                2: "selectionIcon"
            }
        },
        {///BrokerId/Events/Event1/Markets/Market1/Selections/Selection1/SexchangeInfo
            regex: /^\S(\d{1,4})\/E\/E_([0-9]*)$/, method: _onSExchangeInfo, converter: {
                1: "selectionId",
                2: "status",
                3: "selectionResetCount",
                4: "withdrawalFactor",
                5: "settledTime",
                6: "resultString",
                7: "voidPercentage",
                8: "leftSideFactor",
                9: "rightSideFactor",
                10: "redboxSelection"
            }
        },
        {///BrokerId/Events/Event1/Markets/Market1/Selections/Selection1/SelectionLanguage/Language5
            regex: /^\S(\d{1,4})\/E\/E_([0-9]*)$/, method: _onLanguage5, converter: {
                1: "name"
            }
        },
        {
            regex: /^.*\/E\/E_([0-9]*)\/TV\/(.*)$/, method: _onTaggedValue1, converter: {
                1: "value"
            },
            onTopicStatusChange: function (params) { //params = eventId, taggedName
                var thisEvent = getOrCreateSubscribedEvent(params[1]);
                if (thisEvent && thisEvent.taggedValues) {
                    delete thisEvent.taggedValues[params[2]];
                    var changes = { taggedValues: {} };
                    changes.taggedValues[params[2]] = null;

                    thisEvent.prototype.fireDeltaDelegates(changes);
                }

            }
        },
        {
            regex: /^.*\/M\/E_([0-9]*)\/TV\/(.*)$/, method: _onTaggedValue2, converter: {
                1: "value"
            },
            onTopicStatusChange: function (params) { //params = eventId, taggedName
                var thisMarket = getOrCreateSubscribedMarket(params[1]);
                if (thisMarket && thisMarket.taggedValues) {
                    delete thisMarket.taggedValues[params[2]];
                    var changes = { taggedValues: {} };
                    changes.taggedValues[params[2]] = null;

                    thisMarket.prototype.fireDeltaDelegates(changes);
                }

            }
        },
        {
            regex: /^.*\/M\/E_([0-9]*)\/ML\/([a-z\d\-\-]{2})$/, method: _onLanguage7, converter: {
                1: "name"
            }
        },
        {
            regex: /^.*\/M\/E_([0-9]*)\/MEI$/, method: _onMExchangeInfo, converter: {
                1: "marketId",
                2: "marketType",
                3: "isPlayMarket",
                4: "canBeInRunning",
                5: "managedWhenInRunning",
                6: "isVisibleAsTradingMarket",
                7: "isVisibleAsPricedMarket",
                8: "isEnabledForMultiples",
                9: "isCurrentlyInRunning",
                10: "status",
                11: "withdrawAction",
                12: "ballotOutAction",
                13: "canBeDeadHeated",
                14: "startTime",
                15: "delayFactor",
                16: "numberOfWinningSelections",
                17: "withdrawalSequenceNumber",
                18: "resultString",
                19: "numberOfSelections",
                20: "placePayout",
                21: "redboxSPAvailable",
                22: "bOGAvailable",
                23: "numberWinningPlaces",
                24: "placeFraction",
                25: "bettingTypeId"
            }
        },
        { regex: /^.*\/M\/E_([0-9]+)\/MEI\/MEL\/([a-z\d\-\-]{2})$/, method: _onLanguage3, converter: { 1: "name", 2: "description", 3: "marketBlurb" } },
        { regex: /^.*\/M\/E_([0-9]+)\/S\/E_([0-9]+)$/, method: _onSelection1, converter: { 1: "displayOrder", 2: "selectionIcon" } },
        { regex: /^.*\/M\/E_([0-9]+)\/S\/E_([0-9]+)\/SL\/[a-z\d\-\-]{2}$/, method: _onLanguage5, converter: { 1: "name" } },
        { regex: /^.*\/S\/E_([0-9]+)\/SEI$/, method: _onSExchangeInfo, converter: { 1: "selectionId", 2: "status", 3: "selectionResetCount", 4: "withdrawalFactor", 5: "settledTime", 6: "resultString", 7: "voidPercentage", 8: "leftSideFactor", 9: "rightSideFactor", 10: "redboxSelection" } },
        { regex: /^.*\/S\/E_([0-9]+)\/SEI\/SB$/, method: _onSelectionblurb, converter: { 1: "selectionBlurb" } },
        { regex: /^.*\/M\/E_([0-9]+)\/S\/E_([0-9]*)\/SEI\/SEL\/([a-z\d\-\-]{2})$/, method: _onLanguage6, converter: { 1: "name", 2: "selectionBlurb" } },
        { regex: /^.*\/M\/E_([0-9]*)\/MEI\/MDP\/(\d\d?)_(\d\d?)_(\d*)_([A-Z]{3})_([1-3])$/, method: _onBackLayVolumeCurrencyOddsFormat, converter: { 1: [{ 1: "selectionId", 2: [{ 1: "displayPrice", 2: "stake" }], 3: [{ 1: "displayPrice", 2: "stake" }], 4: "redboxDisplayPrice", 5: "redboxFractionalPrice" }] } },
        { regex: /^.*\/M\/E_([0-9]+)\/MEI\/MMA\/([A-Z]{3})$/, method: _onCurrency3, converter: { 1: "forSideAmount", 2: "againstSideAmount" } },
        { regex: /^.*\/M\/E_([0-9]*)\/MEI\/FO\/([A-Z]{1})$/, method: _onFixedOddsMarketPrices, converter: { 1: [{ 1: "selectionId", 2: "price" }] } },
        { regex: /^\S(\d{1,4})\/D\S1$/, method: _onSetAnonymousSessionContext, converter: { 0: "correlationId", 1: "returnCode", 2: "maximumMessageSize" } },
        { regex: /^\S(\d{1,4})\/D\S2$/, method: _onLogonPunter },
        { regex: /(\d{1,4})\/D\S3.*$/, method: _onLogoffPunter },
        { regex: /(\d{1,4})\/D\S10$/, method: _onSubscribeDetailedMarketPrices },
        { regex: /(\d{1,4})\/D\S11$/, method: _onSubscribeFixedOddsMarketPrices },
        { regex: /(\d{1,4})\/D\S12$/, method: _onSubscribeEventHierarchy, converter: { 0: "correlationId", 1: "returnCode", 2: "subscriptionId" } },
        { regex: /(\d{1,4})\/D\S14$/, method: _onSubscribeMarketMatchedAmounts },
        { regex: /(\d{1,4})\/D\S20.*$/, method: _onUnsubscribe },

        //General Application Commands
        { regex: /(\d{1,4})\/D\S22.*$/, method: _onPing },
        { regex: /(\d{1,4})\/D\S$/, method: _onBlankInfo }

    ];

    gecUnseal();
    gec.Controller.prototype._addPushRegex(_regexArrayExchange);



    /*****************************
    TYPEs
    ****************************/



    gec.AAPIRequest = function (params) {
        this.header = gecPrivate._GBEHeader;
        this.callbackOnException = params.callbackOnException;
        this.callbackOnSuccess = params.callbackOnSuccess;
    };

    gec.ExchangePrice = function (params) {

        this.price;
        this.displayPrice;
        this.amountAvailable;
        this.hasRecentlyChanged;

        if (params !== undefined) {
            this.price = params.price;
            this.displayPrice = params.displayPrice;
            this.amountAvailable = params.amountAvailable;
            this.hasRecentlyChanged = params.hasRecentlyChanged;
        }
    };

    gec.ExchangeTrade = function (params) {
        this.selectionId;
        this.marketId;
        this.occurredAt;
        this.backersStake;
        this.layersLiability;
        this.tradeType;
    };

    gec.Order = function (obj) {
        //Properties
        var _eventClassifierId;

        this.orderId;
        this.issuedAt;
        this.polarityId;
        this.unmatchedStake = 0;
        this.requestedPrice = 0;
        this.requestedAveragePrice = 0;
        this.averageMatchedPrice = 0;
        this.matchedStake = 0;
        this.matchedAgainstStake = 0;
        this.orderStatusId;
        this.expiresAt;
        this.cancelOnInRunning;
        this.isCurrentlyInRunning;
        this.willBeInRunning;
        this.cancelIfSelectionReset;
        this.orderPAndL;
        this.isFreeBet;

        if (obj) {
            if (obj.eventClassifierId != undefined)
                gecPrivate._eventClassifierId = obj.eventClassifierId;

        }

        //Methods
        this.eventClassifierId = function () { return gecPrivate._eventClassifierId; }
        this.eventClassifierFullName = function () { return obj.eventClassifierFullName; } // – returns string containing the full name of the EventClassifier that directly contains the market on which the order was issued. The EventClassifiers are separated by a ‘~’ character. Returns null if not known.
        this.marketId = function () { return obj.marketId; } // – returns the id (if known) of the Market on which the order was issued. Returns null if not known.
        this.marketName = function () { return obj.marketName; } // – returns string containing the name (if known) of the Market on which the order was issued. Returns null if not known.
        this.marketStatusId = function () { return obj.marketStatusId; } // – returns the id of the MarketStatus (if known) of the Market on which the order was issued. Returns null if not known.
        this.marketTypeId = function () { return obj.marketType; } // – returns the id of the MarketType (if known) of the Market on which the order was issued. Returns null if not known.
        this.marketTypeName = function () { return obj.marketTypeName; } // – returns string containing the name of the MarketType (if known) of the Market on which the order was issued. Returns null if not known.
        this.selectionId = function () { return obj.selectionId; } // – returns the id of the Selection on which the order was issued.
        this.selectionName = function () {//if known else null
            return obj.selectionName;
        }
        this.selectionStatusId = function () {
            if (obj != null)
                if (obj.selection != null)
                    return obj.selection.selectionStatusId;

            return null;
        } //– returns the id of the SelectionStatus (if known) of the Selection on which the order was issued. Returns null if not known.
    };

    gec.OrderActionType = function (params) {
        this.id;
        this.name;
    };
    gec.OrderDetail = function (params) {
        this.prototype = new gec.Order(params);
        this.eventClassifierFullName;

        this.marketId;
        this.marketName;
        this.selectionId;
        this.selectionName;
        this.orderStatusId;
        this.issuedAt;
        this.lastChangedAt;

        this.expiresAt;
        this.orderFillType;
        this.fillOrKillThreshold;
        this.marketTypeId;
        this.marketStatusId;
        this.requestedStake;
        this.requestedPrice;
        this.requestedAveragePrice;
        this.expectedSelectionResetCount;
        this.expectedWithdrawalSequenceNumber;
        this.matchedStake;
        this.unmatchedStake;
        this.averageMatchedPrice;
        this.totalForSideMakeStake;
        this.totalForSideTakeStake;
        this.polarityId;
        this.withdrawRepriceOptionId;
        this.taxChargingBasis;
        this.taxRate;
        this.isFreeBet;
        this.cancelOnInRunning;
        this.cancelIfSelectionReset;

        this.orderPAndL;

        this.orderCommission;
        this.marketCommission;
        this.taxAmountDeducted;
        this.marketSettledDate;

        this.getHistory = function () { return; };
    };
    gec.OrderHistoryItem = function (params) {
        this.header = gecPrivate._GBEHeader;
        if (params != null) {
            this.callbackOnException = params.callbackOnException;
            this.callbackOnSuccess = params.callbackOnSuccess;
        }
    };
    gec.SubscribedExchangeEvent = function (params) {

        var _thisObject = this;
        this.prototype = new gec.SubscribedObjectBase(_thisObject);

        this.displayOrder;
        this.genericId;
        this.genericName;
        this.eventClassifierId;

        this.name;
        this.isEnabledForMultiples;

        this.prototype._isInitiallyLoaded = function () {
            var returnVal = ((_thisObject.displayOrder != null) &&
                (_thisObject.genericId != null) &&
                //(_thisObject.parentGenericId !== undefined) &&
                (_thisObject.genericName != null) &&
                (_thisObject.eventClassifierId != null) &&
                //(_thisObject.parentClassifierId !== undefined) &&
                (_thisObject.name != null) &&
                (_thisObject.isEnabledForMultiples != null));

            return returnVal;
        }

        this.addDelegate = function (delegate) {
            return this.prototype.addDelegate(delegate);
        };
        this.removeDelegate = function (delegate) {
            this.prototype.removeDelegate(delegate);
        };

    };

    gec.SubscribedExchangeMarket = function (params) {

        var _thisObject = this;
        this.prototype = new gec.SubscribedObjectBase(_thisObject);
        this.displayOrder;
        this.genericId;
        this.genericName;
        this.eventClassifierId;
        this.marketId;
        this.name;
        this.description;
        this.marketBlurb;
        this.marketType;
        this.isPlayMarket;
        this.canBeInRunning;
        this.managedWhenInRunning;
        this.isVisibleAsTradingMarket;
        this.isVisibleAsPricedMarket;
        this.isEnabledForMultiples;
        this.effectiveMarketTradingRestriction;
        this.isCurrentlyInRunning;
        this.status;
        this.withdrawAction;
        this.ballotOutAction;
        this.canBeDeadHeated;
        this.startTime;
        this.delayFactor;
        this.numberOfWinningSelections;
        this.withdrawalSequenceNumber;
        this.resultString;
        this.numberOfSelections;
        this.placePayout;

        this.prototype._isInitiallyLoaded = function () {

            var returnVal = ((_thisObject.displayOrder != null) &&
                (_thisObject.genericId != null) &&
                //  (_thisObject.genericName != null) &&
                (_thisObject.eventClassifierId != null) &&
                (_thisObject.marketId != null) &&
                (_thisObject.name != null) &&
                (_thisObject.marketType != null) &&
                (_thisObject.isPlayMarket != null) &&
                (_thisObject.canBeInRunning != null) &&
                (_thisObject.managedWhenInRunning != null) &&
                (_thisObject.isVisibleAsTradingMarket != null) &&
                (_thisObject.isVisibleAsPricedMarket != null) &&
                (_thisObject.isEnabledForMultiples != null) &&
                (_thisObject.isCurrentlyInRunning != null) &&
                (_thisObject.status != null) &&
                //(_thisObject.withdrawAction != null) &&
                //(_thisObject.ballotOutAction != null) &&
                //(_thisObject.canBeDeadHeated != null) &&

                (_thisObject.numberOfWinningSelections != null) &&
                (_thisObject.withdrawalSequenceNumber != null));

            return returnVal;
        }

        this.addDelegate = function (delegate) {
            return this.prototype.addDelegate(delegate);
        };
        this.removeDelegate = function (delegate) {
            this.prototype.removeDelegate(delegate);
        };

        this.getPlaceFraction = function () {

            if (!isEachWayMarketType(this)) {
                return 0.0;
            }

            if (this.marketType == 21) {
                return Math.round(1 / this.numberOfWinningSelections * 100) / 100;
            }

            var competingSelectionCount = getCompetingSelectionCount(this);

            if (competingSelectionCount < 5) {
                return 1;
            }

            if (this.marketType == 19 && competingSelectionCount > 7) {
                return 0.2;
            }

            if (this.marketType == 20 && competingSelectionCount >= 8 && competingSelectionCount <= 11) {
                return 0.2;
            }

            return 0.25;
        }

        var isEachWayMarketType = function (m) {
            return (m.marketType == 19 || m.marketType == 20 || m.marketType == 21);
        }

        var COMPETING_STATUSES = [2, 6, 7, 8];

        var getCompetingSelectionCount = function (m) {
            var count = 0;

            for (s in m.selections) {
                if (COMPETING_STATUSES[m.selections[s].status] !== undefined || COMPETING_STATUSES[m.selections[s].selectionStatusId] !== undefined) {
                    count++;
                }
            }

            return count;
        }

    };
    gec.SubscribedExchangeEventTab = function (params) {
        var tabs = {}, t;

        this.getTabs = function () {
            var tabArray = [];

            for (t in tabs) {
                tabArray.push(tabs[t]);
            }

            tabArray.sort(function (a, b) {
                return a.displayOrder - b.displayOrder;
            });

            return tabArray;
        };

        this.addTab = function (tabId, tab) {
            tabs[tabId] = tabs[tabId] || {};
            tabs[tabId].tabId = tabId;
            tabs[tabId] = gecPrivate._base.extend(tabs[tabId], tab);
        };

        this.removeTab = function (tabId) {
            delete tabs[tabId];
        };
    };
    gec.SubscribedExchangeMarketMatchedAmount = function (params) {
        var _thisObject = this;
        this.prototype = new gec.SubscribedObjectBase(_thisObject);

        this.prototype._isInitiallyLoaded = function () {
            return true; //not waiting on any ther parts
        };
        this.addDelegate = function (delegate) {
            return this.prototype.addDelegate(delegate);
        };
        this.removeDelegate = function (delegate) {
            this.prototype.removeDelegate(delegate);
        };
    };
    gec.SubscribedExchangeMarketNew = function (params) {
        this.prototype = new gec.SubscribedObjectBase(_thisObject);
    };
    gec.SubscribedExchangeSelection = function (params) {
        var _thisObject = this;
        this.prototype = new gec.SubscribedObjectBase(_thisObject);
        this.genericId;
        this.genericName;
        this.displayOrder;
        this.selectionIcon;
        this.name;
        this.selectionBlurb;
        this.marketId;
        this.selectionId;
        this.status;
        this.selectionResetCount;
        this.withdrawalFactor;
        this.settledTime;
        this.resultString;
        this.voidPercentage;
        this.leftSideFactor;
        this.rightSideFactor;

        this.prototype._isInitiallyLoaded = function () {
            return ((_thisObject.displayOrder != null) && (_thisObject.name != null) && (_thisObject.status != null));
        }

        this.addDelegate = function (delegate) {
            return this.prototype.addDelegate(delegate);
        };
        this.removeDelegate = function (delegate) {
            this.prototype.removeDelegate(delegate);
        };

    };
    gec.SubscribedExchangeSelectionMatchedAmount = function (params) {
        this.prototype = new gec.SubscribedObjectBase(_thisObject);
    };
    gec.SubscribedItemNames = function (params) {
        this.prototype = new gec.SubscribedObjectBase(_thisObject);
    };
    gec.SubscribedMarketScores = function (params) {
        this.prototype = new gec.SubscribedObjectBase(_thisObject);
    };
    gec.SubscribedOrder = function (params) {
        this.prototype = new gec.SubscribedObjectBase(_thisObject);
    };

    /*SubscribedExchangeSelectionPrices*/
    gec.SubscribedExchangeSelectionPrices = function (params) {
        var _thisObject = this;
        this.prototype = new gec.SubscribedObjectBase(_thisObject);

        this.marketId;
        this.selectionId;

        this.backPrices = []; //{	displayPrice:string,stake: gec.MoneyValue}
        this.layPrices = []; //{	displayPrice:string,stake: gec.MoneyValue}

        this.prototype._isInitiallyLoaded = function () {
            return (_thisObject.selectionId != null);
        }

        this.addDelegate = function (delegate) {
            return this.prototype.addDelegate(delegate);
        };
        this.removeDelegate = function (delegate) {
            this.prototype.removeDelegate(delegate);
        };
    };
    gec.SubscribedExchangeSelectionFixedOddsPrices = function (params) {
        var _thisObject = this;
        this.marketId;
        this.selectionId;
        this.backReferencePrice;
        this.layReferencePrice;

        this.prototype = new gec.SubscribedObjectBase(_thisObject);

        this.prototype._isInitiallyLoaded = function () {
            return (_thisObject.selectionId != null);
        }

        this.addDelegate = function (delegate) {
            return this.prototype.addDelegate(delegate);
        };
        this.removeDelegate = function (delegate) {
            this.prototype.removeDelegate(delegate);
        };
    };
    gec.SubscribedSelectionPAndL = function (params) {
        var _thisObject = this;
        this.prototype = new gec.SubscribedObjectBase(_thisObject);
    };
    gec.SubscribedSelectionPriceHistory = function (params) {
        var _thisObject = this;
        this.prototype = new gec.SubscribedObjectBase(_thisObject);
    };


    //gecSeal();

    return gec;

}(window.gec || {}));

//window.gec.gecSeal(); // prevent access to private props
